
import { AppObjects } from './../../services/app-objects';
import { Component, OnInit, ViewChild } from '@angular/core';
import {
  FormGroup,
  Validators,
  FormControl,
  FormBuilder,
  FormArray,
  AbstractControl,
} from '@angular/forms';
import { OrganizationSetupCommon } from './../organization-setup.common';
import { NgbModal, NgbTabset, NgbTypeahead } from '@ng-bootstrap/ng-bootstrap';
import { OrganizationSetupService } from 'src/app/services/organization-setup.service';
import * as moment from 'moment';
import { AppPattern } from 'src/app/services/app-pattern';
import { Router } from '@angular/router';
import { HumanResourceService } from 'src/app/services/human-resource.service';
import { MasterDataService } from '../../services/master-data.service';
import { NullVisitor } from '@angular/compiler/src/render3/r3_ast';
import { CommonMessageService } from '../../services/common-message.service';
import Swal from 'sweetalert2';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-client',
  templateUrl: './client.component.html',
  styleUrls: ['./client.component.css'],
})
export class ClientComponent implements OnInit {
  appPattern = new AppPattern();
  appObj = new AppObjects();
  formObj: any;
  formObjList = [];
  formStatus: any;
  formSubmitted = false;

  chargableToClientList = [
    { id: '1', name: 'Yes', value: true },
    { id: '2', name: 'No', value: false },
  ];




  activateCinNumberList = [
    { id: 1, name: "Public Company-listed" },
    { id: 2, name: "Public Company-unlisted" },
    { id: 3, name: "Public Bank - listed" },
    { id: 4, name: "Public Bank - unlisted" },
    { id: 5, name: "Private Limited Company" },
    { id: 6, name: "Private Limited Bank" }];

  activatellpinNumberList = [{ id: 1, name: "Limited Liability Partnership" }];

  cinActiveFlag = false;
  llpinActiveFlag = false;

  ediaryStatusList = this.appObj.ediaryStatusList;
  legalStatusList = this.appObj.legalStatusList;
  sectorList: any;
  branchList: any;
  financialYearList: any;
  roleList: any;
  serviceVerticalList: any;
  assignmentList: any;
  assignmentListBudget: any;
  assignedPartnerList: any;
  locationList: any;
  partnerList: any;
  checkList: any;
  stateList: any;

  clientCityList: any;
  clientPostcodeList: any;
  showClientCity = false;
  showClientPostCode = false;
  multipleEmails = false;
  locationCityList: any;
  locationPostCodeList: any;
  locationCityListEnable: any;
  locationPostCodeListEnable: any;

  formErrors = OrganizationSetupCommon.clientFormErrors;
  formValidationMessages = OrganizationSetupCommon.clientFormValidationMessages;

  @ViewChild('modalContent') private modalContent;
  @ViewChild('tabsetChecklist') private tabsetChecklist: NgbTabset;
  showChecklist = false;

  query = '';
  limit = 5;
  page = 0;
  recordFrom = 1;
  recordTo = this.limit;

  showNextButton = true;
  partnerFound = false;

  assignmentChecked: boolean;

  constructor(
    private OrganizationSetupService: OrganizationSetupService,
    private humanResourceService: HumanResourceService,
    private masterDataService: MasterDataService,
    private fb: FormBuilder,
    private modalService: NgbModal,
    public router: Router,
    private commonMessageService: CommonMessageService
  ) { }

  // Pagination
  searchClientsByName() {
    console.log(this.query);
    this.masterDataService.getClientByName(this.query).subscribe((res: any) => {
      console.log(res);
      // var tempList = [...this.formObjList];
      // this.formObjList = tempList.concat(res);
      var oldList = [...this.formObjList];
      var newList = [...res];
      var ids = new Set(oldList.map((d) => d.id));
      this.formObjList = [...oldList, ...newList.filter((d) => !ids.has(d.id))];
      console.log('load formobject list', res);

    });
  }

  loadPreviousClients() {
    if (this.page > 0) {
      this.page = this.page - 1;
      this.masterDataService
        .getClients(this.page, this.limit)
        .subscribe((res: any) => {
          this.formObjList = res;
          window.scroll(0, 0);
        });
    }
  }

  onMultipleEmailsChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.multipleEmails = input.checked;
    console.log('Multiple Emails:', this.multipleEmails);
  }

  loadNextClients() {
    this.page = this.page + 1;
    this.masterDataService
      .getClients(this.page, this.limit)
      .subscribe((res: any) => {
        console.log(res);
        this.formObjList = res;
        window.scroll(0, 0);
        // this.recordFrom = this.recordTo+1;
        // this.recordTo = this.recordTo+this.recordTo;
      });
  }

  initVariables() {
    this.locationCityList = [];
    this.locationPostCodeList = [];
    this.locationCityListEnable = [];
    this.locationPostCodeListEnable = [];
    this.showChecklist = false;
    this.formSubmitted = false;
    this.showClientCity = false;
    this.showClientPostCode = false;
  }


  ngOnInit(): void {
    console.log("initform")
    this.locationCityList = [];
    this.locationPostCodeList = [];
    this.formStatus = 'view';
    this.initForm();

    // this.loadChecklist();
    this.loadClientLookups();
    this.initVariables();
    // When any of the form control value in employee form changes
    // our validation function logValidationErrors() is called
    this.formObj.valueChanges.subscribe((data) => {
      this.logValidationErrors(this.formObj);
    });
    this.formObj.get('role')?.valueChanges.subscribe((role) => {
      this.onRoleChange(role);
    });
  }

  // loadChecklist() {
  //   this.masterDataService.getCheckList().subscribe((res) => {
  //     console.log(res);
  //     this.checkList = res;
  //     // this.loadAssignments();
  //     // this.initChecklistFormArray();
  //   });
  // }

  // Initialize Dropdown Lists

  loadClientLookups() {
    this.masterDataService.getClientLookups().subscribe(
      (res: any) => {
        console.log("lookup patching" + res);
        this.checkList = res.checklist;
        this.assignmentList = res.assignments;
        // this.locationList = res.location;
        this.partnerList = res.partners;
        console.log('partner list', this.partnerList);
        this.branchList = res.branch;
        this.sectorList = res.sector;
        this.stateList = res.states;
        this.loadClients();
      },
      (error) => {
        // console.log(error);
      }
    );
  }

  loadClients() {
    this.masterDataService
      .getClients(this.page, this.limit)
      .subscribe((res: any) => {
        console.log(res);
        this.formObjList = res;
        // this.loadState();
        this.initializeChecklist();
      });
  }

  initializeChecklist() {
    this.checkList.forEach((element, key) => {
      element.isRequired = false;
      element.remark = '';
    });
    this.initChecklistFormArray();
  }



  // Form Object
  initForm() {
    this.formObj = this.fb.group({
      id: [''],
      name: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      pan: [
        '',
        [Validators.required, Validators.pattern(this.appPattern.PAN_PATTERN)],
      ],
      address: ['', [Validators.required]],
      state: [null, [Validators.required]],
      city: [null, [Validators.required]],
      postCode: [null, [Validators.required]],
      // alias: ['', [Validators.required]],
      chargeableToClient: [null, [Validators.required]],
      cinNumber: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9]{21}$/)]],
      gstNumber: ['', [Validators.required, Validators.pattern(this.appPattern.GST_PATTERN)]],      // principalPlaceOfBusiness: ['', [Validators.required]],
      ediaryStatus: [null, [Validators.required]],
      legalStatus: [null, [Validators.required]],
      llpinNumber: [null, [Validators.required, Validators.pattern(/^[A-Z]{3}-\d{4}$/)]],
      branch: [null, [Validators.required]],
      sector: [null, [Validators.required]],
      partners: this.fb.array([this.addPartnerFormGroup()]),
      // clientEmails: this.fb.array([ this.addEmailFormGroup(),
      //   this.addEmailFormGroup(),
      //   this.addEmailFormGroup()]),
      clientEmails: this.fb.array([]),
      clientLocations: this.fb.array([]),
      clientCheckList: this.fb.array([]),
      isSign: [null],
      signDate: [null],
      financialYear: [null],
      assignedPartner: [null],
      assignment: [null],
      assignmentFees: [null],
      role: [null],
      serviceVertical: [null],
      employee: [null],
      budgetDetails: this.fb.array([]),
    });

    this.loadFinancialYear();
    this.loadRoles();
    this.loadServiceVerticals();
  }

  get clientEmails(): FormArray {
    return this.formObj.get('clientEmails') as FormArray;
  }

  initChecklistFormArray() {
    console.log(this.checkList);
    this.formObj.controls['clientCheckList'].clear();
    this.checkList.forEach((checklist, key) => {
      (<FormArray>this.formObj.get('clientCheckList')).push(
        this.fb.group({
          id: '',
          questionId: [checklist.id],
          questionNo: [checklist.questionNo],
          question: [checklist.question],
          isRequired: [checklist.isRequired],
          remark: [checklist.remark],
        })
      );
    });
  }

  // loadAssignments() {
  //   this.masterDataService.getAssignments().subscribe((res) => {
  //     console.log(res);
  //     this.assignmentList = res;
  //     this.loadLocation();
  //   });
  // }

  // loadLocation() {
  //   this.masterDataService.getLocations().subscribe((res) => {
  //     console.log(res);
  //     this.locationList = res;
  //     this.loadPartners();
  //   });
  // }

  // loadPartners() {
  //   this.masterDataService.getPartners().subscribe((res) => {
  //     console.log(res);
  //     this.partnerList = res;
  //     // this.partnerList.forEach((element,key) => {
  //     //   element.id=key;
  //     // });
  //     this.loadBranch();
  //   });
  // }

  // loadBranch() {
  //   this.masterDataService.getBranch().subscribe((res) => {
  //     console.log(res);
  //     this.branchList = res;
  //     this.loadSector();
  //   });
  // }

  // loadSector() {
  //   this.masterDataService.getSectors().subscribe((res) => {
  //     console.log(res);
  //     this.sectorList = res;
  //     // this.loadEdiaryStatus();
  //     this.loadClients();
  //   });
  // }

  // loadEdiaryStatus() {
  //   this.masterDataService.getEdiaryStatus().subscribe((res) => {
  //     console.log(res);
  //     // this.ediaryStatusList = res;
  //     console.log(JSON.stringify(this.ediaryStatusList))
  //     // this.loadLegalStatus();
  //   });
  // }

  // loadLegalStatus() {
  //   this.masterDataService.getLegalStatus().subscribe((res) => {
  //     console.log(res);
  //     // this.legalStatusList = res;
  //     console.log(JSON.stringify(this.legalStatusList))
  //     // this.loadClients();
  //   });
  // }

  // loadState() {
  //   this.masterDataService.getStates().subscribe((res) => {
  //     console.log(res);
  //     this.stateList = res;
  //   });
  // }
  //------------

  onPartnerChange(index) {
    console.log('index value', index);
    console.log('this.formObj.controls.partners.value[index]', this.formObj.controls.partners.controls[index]);
    if (index > this.selectedPartnerList.length - 1) {
    } else {
      this.commonMessageService.swalAlertWithoutIcon('', 'Can not change partner.');
      this.formObj.controls.partners.controls[index].patchValue({
        id: this.selectedPartnerList[index].id
      })
    }
  }

  disableDateOnPartnerChange: boolean;
  selectedPartnerListWithYear;
  // onPartnerChange(index) {
  //   console.log("parnter index", index)
  //   console.log("parnter index", this.formObj.controls.partners.value[index])
  //   console.log('on partner change edit global response', this.editGlobalResponse);
  //   console.log("selected partnerlist", this.selectedPartnerList)
  //   console.log("old client object", this.selectedPartnerList[index])
  //   console.log('financiarYEar list', this.financialYearList);
  //   if (this.formStatus == 'edit' && this.selectedPartnerList[index] != undefined) {
  //     for (let i = 0; i < this.financialYearList.length; i++) {
  //       if (this.financialYearList[i].startDate == this.selectedPartnerList[index].fromDate ||
  //         this.financialYearList[i].endDate == this.selectedPartnerList[index].toDate) {
  //         this.selectedPartnerListWithYear = {
  //           id: this.selectedPartnerList[index].id,
  //           yearName: this.financialYearList[i].name,
  //           fromDate: this.selectedPartnerList[index].fromDate,
  //           toDate: this.selectedPartnerList[index].toDate
  //         }
  //       }
  //     }
  //     console.log('new selected partnerlist', this.selectedPartnerListWithYear);
  //     for (let i = 0; i < this.editGlobalResponse.budget.length; i++) {
  //       if (this.editGlobalResponse.budget[i].assignedPartner.id == this.selectedPartnerListWithYear.id &&
  //         this.editGlobalResponse.budget[i].financialYear.name == this.selectedPartnerListWithYear.yearName) {
  //         const partnerIndex = this.partnerList.findIndex((item) => item.id == this.formObj.controls.partners.value[index].id);
  //         this.editGlobalResponse.budget[i].assignedPartner = this.partnerList[partnerIndex];
  //       }
  //     }
  //   }
  //   console.log('on partner change edit global response', this.editGlobalResponse);
  // }

  // var partnerBudgetExist = false
  // if (this.formStatus == 'edit' && index <= this.selectedPartnerList.length - 1) {
  //   if (this.editGlobalResponse != null || this.editGlobalResponse != undefined) {
  //     for (let i = 0; i < this.editGlobalResponse.budget.length; i++) {
  //       if (this.editGlobalResponse.budget[i].assignedPartner.id == this.selectedPartnerList[index].id) {
  //         partnerBudgetExist = true;
  //         console.log('assigned partner id', this.selectedPartnerList[index].id);
  //       }
  //     }
  //   }
  // }

  //   // if (partnerBudgetExist) {
  //   //   this.formObj.controls.partners.controls[index].patchValue({
  //   //     id: this.selectedPartnerList[index].id
  //   //   })
  //   //   this.commonMessageService.swalAlertWithoutIcon('',"you cannot change partner as budget is already created ...!")
  //   // }
  //   // }
  // onPartnerChange(partner,Index){
  //   console.log("partner",partner)
  //   console.log("budgetPartnersList",this.budgetPartnersList)
  //   console.log("editGlobalResponse",this.editGlobalResponse)
  //   if(this.formStatus == 'edit'){
  //     var statusFound
  //     for(let i=0;i<this.editGlobalResponse.budget.length;i++){
  //       if(this.editGlobalResponse.budget[i].assignedPartner.id == partner){
  //         if(this.formObj.controls.partners.value[Index].toDate != ""){
  //           var fromDate=new Date(this.formObj.controls.partners.value[Index].fromDate.year + '-' + this.formObj.controls.partners.value[Index].fromDate.month + '-' + this.formObj.controls.partners.value[Index].fromDate.day)
  //           var toDate=new Date(this.formObj.controls.partners.value[Index].toDate.year + '-' + this.formObj.controls.partners.value[Index].toDate.month + '-' + this.formObj.controls.partners.value[Index].toDate.day)
  //           var formattedFromDate = moment(fromDate).format('YYYY-MM-DD')
  //           var formattedToDate =moment(toDate).format('YYYY-MM-DD')
  //           var fy
  //           for(let j=0;j < this.financialYearList.length;j++){
  //             if(formattedFromDate >= this.financialYearList[j].startDate && formattedToDate <= this.financialYearList[j].endDate){
  //              fy= this.financialYearList[j]
  //             }
  //           }
  //           console.log("current FinancialYear",fy)
  //           if(this.editGlobalResponse.budget[i].financialYear.id == fy){
  //             statusFound = true
  //           }
  //         }
  //       }
  //     }
  //     if(statusFound){.
  //     this.commonMessageService.swalAlertWithoutIcon('',"Not able to change partner as budget for assignements is already created")
  //     }
  //   }
  // }

  clientBudgetPartnerList = [];
  previousClientBudgetPartnerList = [];
  onChangeFinancialYear() {
    this.clientBudgetPartnerList = [];
    this.previousClientBudgetPartnerList = [];

    this.assignedPartnerList = [];
    this.formObj.patchValue({
      assignedPartner: null,
      assignment: null,
      assignmentFees: null,
      role: null,
      serviceVertical: null,
      employee: null,
    });
    console.log("selected financialYear ", this.formObj.value.financialYear)
    console.log("budgetPartnersList", this.budgetPartnersList);


    for (let i = 0; i < this.partnerFinancialYearList.length; i++) {
      for (let j = 0; j < this.partnerFinancialYearList[i].financailYear.length; j++) {
        console.log('financial year list', this.partnerFinancialYearList[i]);
        if (this.formObj.value.financialYear.id == this.partnerFinancialYearList[i].financailYear[j].id) {
          this.previousClientBudgetPartnerList.push(this.partnerFinancialYearList[i].partner);
        }
      }
    }
    console.log('previousClientBudgetPartnerList', this.previousClientBudgetPartnerList);
    this.clientBudgetPartnerList = this.previousClientBudgetPartnerList.filter((v, i, a) => a.indexOf(v) === i);
    console.log('clientBudgetPartnerList', this.clientBudgetPartnerList);

    // let uniqueElements = [...new Set(selectedRowFromMultiSeats)];


    // for(let i = 0; i < this.budgetPartnersList.length; i++){
    //   var statusFound=false;
    //   for(let j=0 ; j< this.assignedPartnerList.length; j++){
    //     if(this.budgetPartnersList[i].partner == this.assignedPartnerList[j].id){
    //     statusFound = true
    //     }
    //   }
    //   if(!statusFound){
    //     var index = this.partnerList.findIndex((item) => item.id === this.budgetPartnersList[i].partner);
    //     this.assignedPartnerList.push(this.partnerList[index])
    //   }
    // }
    // for(let i = 0; i < this.budgetPartnersList.length; i++){
    //   if(this.formObj.value.financialYear.id == this.budgetPartnersList[i].financialYear.id){
    //     var index = this.partnerList.findIndex((item) => item.id === this.budgetPartnersList[i].partner);
    //     this.assignedPartnerList.push(this.partnerList[index])
    //   }
    // }
  }

  budgetFinancialYearList;
  budgetPartnersList = []

  loadFinancialYearListForBudget() {
    // this.budgetFinancialYearList = null
    this.budgetPartnersList = []

    this.masterDataService.getCurrentAndLastfinancialYear()
      .subscribe((res) => {
        console.log("budgetFinancialYearList", res);
        this.budgetFinancialYearList = res
      });

    console.log(" this.formObj.controls.partners.value", this.formObj.controls.partners.value)

    for (let i = 0; i < this.formObj.controls.partners.value.length; i++) {
      var fromDate = new Date(this.formObj.controls.partners.value[i].fromDate.year + '-' + this.formObj.controls.partners.value[i].fromDate.month + '-' + this.formObj.controls.partners.value[i].fromDate.day)
      var toDate = new Date(this.formObj.controls.partners.value[i].toDate.year + '-' + this.formObj.controls.partners.value[i].toDate.month + '-' + this.formObj.controls.partners.value[i].toDate.day)
      var formattedFromDate = moment(fromDate).format('YYYY-MM-DD')
      var formattedToDate = moment(toDate).format('YYYY-MM-DD')
      var fy;
      for (let j = 0; j < this.financialYearList.length; j++) {
        if (formattedToDate <= this.financialYearList[j].endDate || formattedFromDate <= this.financialYearList[j].startDate) {
          fy = this.financialYearList[j]
        }
      }
      var budgetPartnerObj = {
        financialYear: fy,
        partner: this.formObj.controls.partners.value[i].id,
        assignments: this.formObj.controls.partners.value[i].assignments
      }
      this.budgetPartnersList.push(budgetPartnerObj)
    }
    console.log("budgetPartnersList", this.budgetPartnersList)

    // for(let i = 0; i < this.budgetPartnersList.length; i++){
    //   var statusFound = false
    //   for(let j=0; j<this.budgetFinancialYearList.length;j++){
    //     if(this.budgetPartnersList[i].financialYear.id == this.budgetFinancialYearList[j].id){
    //       statusFound = true
    //     }
    //   }
    //   if(!statusFound){
    //     this.budgetFinancialYearList.push(this.budgetPartnersList[i].financialYear)
    //   }
    // }

    // console.log("fyIndex",this.budgetFinancialYearList.length-1)
    // console.log("fy",this.budgetFinancialYearList[this.budgetFinancialYearList.length-1])
    // this.formObj.patchValue({
    //   financialYear: null
    // });
  }
  partnerFinancialYearList = []
  loadAssignedPartnerList() {
    console.log('patnerList :', this.formObj.controls.partners.value);
    console.log('patnerList', this.partnerList);
    this.assignedPartnerList = [];
    this.partnerFinancialYearList = []
    for (let i = 0; i < this.formObj.controls.partners.value.length; i++) {
      var statusFound = false
      for (let j = 0; j < this.assignedPartnerList.length; j++) {
        if (this.assignedPartnerList[j].id == this.formObj.controls.partners.value[i].id) {
          statusFound = true
        }
      }
      if (!statusFound) {
        for (let j = 0; j < this.partnerList.length; j++) {
          if (this.formObj.controls.partners.value[i].id == this.partnerList[j].id) {
            this.assignedPartnerList.push(this.partnerList[j]);
          }
        }
      }
    }
    for (let i = 0; i < this.formObj.controls.partners.value.length; i++) {
      var partner = null
      var assignments = []
      var financailYear = [];
      var toDate = new Date(this.formObj.controls.partners.value[i].toDate.year + '-' + this.formObj.controls.partners.value[i].toDate.month + '-' + this.formObj.controls.partners.value[i].toDate.day)
      var formattedToDate = moment(toDate).format('YYYY-MM-DD');
      var fromDate = new Date(this.formObj.controls.partners.value[i].fromDate.year + '-' + this.formObj.controls.partners.value[i].fromDate.month + '-' + this.formObj.controls.partners.value[i].fromDate.day)
      var formattedFromDate = moment(fromDate).format('YYYY-MM-DD');
      for (let j = 0; j < this.partnerList.length; j++) {
        if (this.formObj.controls.partners.value[i].id == this.partnerList[j].id) {
          partner = this.partnerList[j]
        }
      }
      for (let k = 0; k < this.financialYearList.length; k++) {
        if ((formattedToDate <= this.financialYearList[k].endDate || formattedFromDate <= this.financialYearList[k].startDate || formattedFromDate < this.financialYearList[k].endDate) && formattedToDate > this.financialYearList[k].startDate) {
          console.log('this.financialYearList[k]', this.financialYearList[k]);
          financailYear.push(this.financialYearList[k]);
        }
      }
      assignments = this.formObj.controls.partners.value[i].assignments
      if (financailYear == null && formattedToDate > this.financialYearList[this.financialYearList.length - 1].endDate) {
        financailYear = this.financialYearList[0]
      }
      var data = {
        partner: partner,
        assignments: assignments,
        financailYear: financailYear
      }
      this.partnerFinancialYearList.push(data);
    }
    console.log('assignmentPatnerList', this.assignedPartnerList);
    console.log('partnerFinancialYearList', this.partnerFinancialYearList);
  }

  checkListAssignments = []
  loadAssignmentsListForCheckList() {
    this.checkListAssignments = []

    console.log("budgetPartnersList", this.budgetPartnersList)
    for (let i = 0; i < this.budgetPartnersList.length; i++) {
      for (let j = 0; j < this.budgetPartnersList[i].assignments.length; j++) {
        var statusFound = false
        for (let k = 0; k < this.checkListAssignments.length; k++) {
          if (this.checkListAssignments[k].id == this.budgetPartnersList[i].assignments[j].id) {
            statusFound = true
          }
        }
        if (!statusFound) {
          this.checkListAssignments.push(this.budgetPartnersList[i].assignments[j])
        }
      }
    }
    console.log("checkListAssignments", this.checkListAssignments)
  }

  clientBudgetAssignmentList = [];
  loadAssignmentList() {
    this.clientBudgetAssignmentList = [];
    console.log("assignmentPartnerBudget ::", this.formObj.value.assignedPartner);
    console.log("financialYearBudget ::", this.formObj.value.financialYear);



    for (let i = 0; i < this.partnerFinancialYearList.length; i++) {

      const partnerObj = this.partnerFinancialYearList[i].partner;

      if (partnerObj && this.formObj.value.assignedPartner.id == this.partnerFinancialYearList[i].partner.id) {
        for (let j = 0; j < this.partnerFinancialYearList[i].financailYear.length; j++) {
          if (this.formObj.value.financialYear.id == this.partnerFinancialYearList[i].financailYear[j].id) {
            this.clientBudgetAssignmentList = this.partnerFinancialYearList[i].assignments;
          }
        }
      }
    }
    console.log("this.clientBudgetAssignmentList", this.clientBudgetAssignmentList);

    // for(let i=0;i<this.budgetPartnersList.length;i++){
    //   if(this.formObj.value.assignedPartner.id == this.budgetPartnersList[i].partner ){
    //       for(let j=0;j<this.budgetPartnersList[i].assignments.length;j++){
    //         var statusFound=false
    //         for(let k=0 ; k<this.assignmentListBudget.length; k++){
    //           if(this.budgetPartnersList[i].assignments[j].id == this.assignmentListBudget[k].id){
    //             statusFound = true
    //           }
    //         }
    //         if(!statusFound){
    //           console.log('inside statusfount')
    //           this.assignmentListBudget.push(this.budgetPartnersList[i].assignments[j])
    //         }
    //       }
    //   }
    // }
    // if(this.clientBudgetAssignmentList.length == 0){
    //   this.commonMessageService.swalAlertWithoutIcon('',"No Assignments present for this partner for "+this.formObj.value.financialYear.name+" financial year")
    // }
  }


  assignmentFeesValue() {
    // console.log('assignment fees',this.formObj.value.assignmentFees);
    // if(this.formObj.value.assignmentFees==0){
    //   this.commonMessageService.swalAlertWithoutIcon('','Assignment Fees Not Enter zero');
    //   this.formObj.controls.assignmentFees.setValue('');
    // }
  }

  loadRoles() {
    this.masterDataService.getRoles().subscribe((res) => {
      console.log(res);
      this.roleList = res;
    });
  }

  loadServiceVerticals() {
    this.masterDataService.getServiceVerticalList()
      .subscribe(res => {
        this.serviceVerticalList = res;
      })
  }

  employeeList: any;
  // loadEmployeesForRoles() {
  //   console.log('role', this.formObj.controls.role.value);
  //   var role = this.formObj.controls.role.value;
  //   if (role.id == 1 && role.name == 'Article') {
  //     this.employeeList = this.clientBudgetPartnerList;
  //   } else {
  //     this.OrganizationSetupService.getEmployeesForRoles(role.id).subscribe(
  //       (res) => {
  //         console.log(res);
  //         this.employeeList = res;
  //       }
  //     );
  //   }
  // }

  compareById = (o1: any, o2: any): boolean => {
    return o1 && o2 ? o1.id === o2.id : o1 === o2;
  };

  onRoleChange(role: any) {
    const serviceVerticalControl = this.formObj.get('serviceVertical');

    if (role?.name === 'Article') {
      serviceVerticalControl?.disable();
      serviceVerticalControl?.reset(null);
      this.loadEmployeesForServiceVerticalAndRoles();
    } else {
      serviceVerticalControl?.enable();
      serviceVerticalControl?.reset(null);
    }
  }

  loadEmployeesForServiceVerticalAndRoles() {

  const role = this.formObj.controls.role.value;
  const serviceVertical = this.formObj.controls.serviceVertical.value;
  const branch = this.formObj.controls.branch.value;

  console.log('LoadEmployee');
  console.log('role', role);
  console.log('branch', branch);
  console.log('serviceVertical', serviceVertical);

  if (!role || role == "null") {
    this.commonMessageService.swalAlertWithoutIcon('', "Please Select Role");
    return;
  }

  if (role.id == 1 && role.name == 'Article') {

    if (this.assignedPartnerList.length == 0) {
      this.loadAssignedPartnerList();
    }

    this.employeeList = this.assignedPartnerList;

    this.formObj.get('serviceVertical')?.clearValidators();
    this.formObj.get('serviceVertical')?.updateValueAndValidity();

  } else {

    this.loadAssignedPartnerList();

    const requests = this.assignedPartnerList.map((partner) =>
      this.masterDataService.getUserProfileByIdForDecleration(partner.userId)
    );

    forkJoin(requests).subscribe((responses: any[]) => {

      const branchIdsString = responses
        .map(res => res?.userOfficialDetails?.branch?.id)
        .filter(id => id != null)
        .join(',');

      console.log('branchIdsString', branchIdsString);

      this.OrganizationSetupService
        .getEmployeesForServiceVerticalAndRoles(
          serviceVertical.id,
          role.id
        )
        .subscribe((res) => {
          console.log('employee list', res);
          this.employeeList = res;
        });

    });
  }
}

  loadFinancialYear() {
    this.masterDataService.getFinancialYear().subscribe((res) => {
      console.log(res);
      this.financialYearList = res;

      var fyIndex = -1;
      this.financialYearList.forEach((element, key) => {
        var startDate = new Date(element.startDate);
        var endDate = new Date(element.endDate);
        var currentDate = moment(new Date()).format('YYYY-MM-DD');
        console.log(startDate, endDate);
        console.log(currentDate);
        if (
          currentDate >= element.startDate &&
          currentDate <= element.endDate
        ) {
          fyIndex = key;
        }
      });

      // this.formObj.patchValue({
      //   financialYear: this.financialYearList[fyIndex],
      // });
    });
  }

  onLegalStatusChange() {

    if (this.formObj.value.legalStatus) {
      console.log('legal status change', this.formObj.value.legalStatus)
      console.log('cin>>', this.formObj.value.cinNumber)
      // Check if the selected value exists in activateCinNumberList

      const match = this.activateCinNumberList.some(item => item.name == this.formObj.value.legalStatus.name);

      // Set cinActiveFlag based on the result
      this.cinActiveFlag = match;
    }
    else {
      this.cinActiveFlag = false;
    }

    if (this.cinActiveFlag) {
      this.addRequiredValidation('cinNumber');
    }
    else {
      this.removeRequiredValidation('cinNumber')
    }

    if (this.formObj.value.legalStatus) {
      console.log('legal status change', this.formObj.value.legalStatus)
      console.log('llpinNumber>>', this.formObj.value.llpinNumber)
      // Check if the selected value exists in activateCinNumberList

      const match = this.activatellpinNumberList.some(item => item.name == this.formObj.value.legalStatus.name);

      // Set cinActiveFlag based on the result
      this.llpinActiveFlag = match;
    }
    else {
      this.llpinActiveFlag = false;
    }

    if (this.llpinActiveFlag) {
      this.addRequiredValidation('llpinNumber');
    }
    else {
      this.removeRequiredValidation('llpinNumber');
    }

  }

  addRequiredValidation(formElementName) {

    if (formElementName == 'cinNumber') {
      this.formObj.get(formElementName).setValidators([Validators.required, Validators.pattern(/^[a-zA-Z0-9]{21}$/)]);
    }
    else if (formElementName == 'llpinNumber') {
      this.formObj.get(formElementName).setValidators([Validators.required, Validators.pattern(/^[A-Z]{3}-\d{4}$/)]);
    }
    this.formObj.get(formElementName).updateValueAndValidity();
  }

  removeRequiredValidation(formElementName) {
    this.formObj.get(formElementName).clearValidators();
    this.formObj.get(formElementName).updateValueAndValidity();
  }


  budgetExist: any;
  onAssignmentSelectBudgetDays;
  checkIfBudgetExist() {
    console.log('clientId', this.formObj.value);
    var yearId = this.formObj.value.financialYear.id,
      branchId = this.formObj.value.branch.id,
      partnerId = this.formObj.value.assignedPartner.id,
      clientId = this.formObj.value.id,
      assignmentId = this.formObj.value.assignment.id;
    console.log('clientId ::', clientId, " branchId ::", branchId, " partnerId ::", partnerId, " clientId ::", clientId, " assignmentId ::", assignmentId);
    console.log("this.editGlobalResponse", this.editGlobalResponse)
    if (clientId == '' || clientId == null) {
    } else {
      console.log("this.editGlobalResponse", this.editGlobalResponse)
      var foundStatus = false
      for (let i = 0; i < this.editGlobalResponse.budget.length; i++) {
        // if(this.editGlobalResponse.budget[i].assignment!=null){
        if (this.editGlobalResponse.budget[i].assignedPartner.id == partnerId &&
          this.editGlobalResponse.budget[i].assignment.id == assignmentId &&
          this.editGlobalResponse.budget[i].financialYear.id == yearId) {
          foundStatus = true
        }
        // }
      }
      if (foundStatus) {
        var checkExistingApiCall = true
        for (let i = 0; i < this.editGlobalResponse.budget.length; i++) {
          // if(this.editGlobalResponse.budget[i].assignment!=null){
          if (this.editGlobalResponse.budget[i].assignedPartner.id == partnerId &&
            this.editGlobalResponse.budget[i].assignment.id == assignmentId &&
            this.editGlobalResponse.budget[i].branch.id == branchId &&
            this.editGlobalResponse.budget[i].client.id == clientId &&
            this.editGlobalResponse.budget[i].financialYear.id == yearId) {
            console.log("1...................................................")
            this.addClientBudgetIntoExistingJson(this.editGlobalResponse);
            this.formObj.controls['budgetDetails'].clear();
            if (this.editGlobalResponse.budget[i].budgetDetails.length > 0) {
              this.budgetExist = this.editGlobalResponse.budget[i];

              console.log('existingBudgetresponse', this.budgetExist);
              this.onAssignmentSelectBudgetDays = this.budgetExist;
              this.formStatus = 'edit';
              this.setValueToClientBudgetForm(this.editGlobalResponse.budget[i]);
              checkExistingApiCall = false
            }
          }
          // }
        }
        console.log('checkExistingApiCall', checkExistingApiCall)
        if (checkExistingApiCall) {
          this.OrganizationSetupService.getExistingBudget(yearId, branchId, partnerId, clientId, assignmentId)
            .subscribe((res: any) => {
              this.addClientBudgetIntoExistingJson(this.editGlobalResponse);
              this.formObj.controls['budgetDetails'].clear();
              console.log('existingBudget', res);
              if (res.budgetDetails.length > 0) {
                this.budgetExist = res;
                console.log('this.onAssignmentSelectBudgetDays', this.onAssignmentSelectBudgetDays);
                this.formStatus = 'edit';
                this.setValueToClientBudgetForm(res);
              }
            },
              (err) => {
                this.addClientBudgetIntoExistingJson(this.editGlobalResponse);
                this.formObj.controls['budgetDetails'].clear();
                console.log(this.formObj.value.budgetDetails);
                // this.formObj.patchValue({
                // assignmentFees: '0',
                // });
              });
        }
      } else {
        this.commonMessageService.swalAlertWithoutIcon('', "The Budget does not exist")
        this.addClientBudgetIntoExistingJson(this.editGlobalResponse);
        this.formObj.controls['budgetDetails'].clear();
        console.log(this.formObj.value.budgetDetails);
        // this.formObj.patchValue({
        //   assignmentFees: '0',
        // });
      }
    }
  }

  setValueToClientBudgetForm(modalObj) {
    console.log('setValueToClientBudgetForm');
    console.log("modalObj ::", modalObj)
    this.formObj.patchValue({
      /* id:modalObj.id, */
      assignmentFees: modalObj.assignmentFees,
    });
    this.formObj.controls['budgetDetails'].clear();
    console.log(modalObj);
    modalObj.budgetDetails.forEach((element, key) => {
      console.log('in for');
      this.addBudgetDetailFormGroupInEdit(element, modalObj);
    });
    console.log(this.formObj.value.budgetDetails);
  }
  removeBudget(index: number) {
    console.log("budgetDetail", this.formObj.controls.budgetDetails.controls[index].value)
    if (
      // confirm('Are you sure you want to delete?')
      Swal.fire({
        text: 'Are you sure you want to delete?',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        confirmButtonColor: '#800000'
      }).then((result) => { })
    ) {
      if (this.formStatus == 'edit') {
        for (let i = 0; i < this.editGlobalResponse.budget.length; i++) {
          if (this.editGlobalResponse.budget[i].assignment != null) {
            if (this.formObj.controls.budgetDetails.controls[index].value.assignment.id == this.editGlobalResponse.budget[i].assignment.id
              && this.formObj.controls.budgetDetails.controls[index].value.partner.id == this.editGlobalResponse.budget[i].assignedPartner.id
              && this.formObj.controls.budgetDetails.controls[index].value.financialYear.id == this.editGlobalResponse.budget[i].financialYear.id) {
              for (let j = 0; j < this.editGlobalResponse.budget[i].budgetDetails.length; j++) {
                if (this.editGlobalResponse.budget[i].budgetDetails[j].id == this.formObj.controls.budgetDetails.controls[index].value.id) {
                  this.editGlobalResponse.budget[i].budgetDetails.splice(j, 1)
                  if (this.editGlobalResponse.budget[i].budgetDetails.length == 0) {
                    this.editGlobalResponse.budget.splice(i, 1)
                  }

                  ///this.editGlobalResponse.budget[i].budgetDetails[j].budgetedDays = this.formObj.controls.budgetDetails.controls[index].value.budgetedDays
                }
              }
            }
          }
        }
        const formArray = <FormArray>this.formObj.get('budgetDetails');
        formArray.removeAt(index);
        formArray.markAsDirty();
        formArray.markAsTouched();
        console.log('afterbudgetdetailsremove', this.editGlobalResponse)
        this.commonMessageService.swalAlertWithIcon('', 'Deleted Successfully!', 'success');
      } else {
        const formArray = <FormArray>this.formObj.get('budgetDetails');
        formArray.removeAt(index);
        formArray.markAsDirty();
        formArray.markAsTouched();
        console.log('afterbudgetdetailsremove', this.editGlobalResponse)
        this.commonMessageService.swalAlertWithIcon('', 'Deleted Successfully!', 'success');
      }
    }
  }
  addBudgetDetailFormGroupInEdit(budgetDetail, modalObj) {
    console.log('in addBudgetDetailFormGroupInEdit');
    const roleIndex = this.roleList.findIndex(
      (item) => item.id == budgetDetail.role.id
    );

    const verticalIndex = this.serviceVerticalList.findIndex(
      (item) => item.id == budgetDetail.serviceVertical.id
    );

    let role: any;
    role = {};
    for (let i = 0; i < this.roleList.length; i++) {
      if (roleIndex == i) {
        role = this.roleList[i];
      }
    }

    let serviceVertical: any;
    serviceVertical = {};
    for (let i = 0; i < this.serviceVerticalList.length; i++) {
      if (verticalIndex == i) {
        serviceVertical = this.serviceVerticalList[i];
      }
    }

    var employeeIndex;
    let user: any;
    let formGroupEdit;
    user = {};
    if (role.id == '1' && role.name == 'Article') {
      this.employeeList = this.clientBudgetPartnerList;
      employeeIndex = this.employeeList.findIndex(
        (item) => item.id == budgetDetail.user.id
      );
      for (let i = 0; i < this.employeeList.length; i++) {
        if (employeeIndex == i) {
          user = this.employeeList[i];
        }
      }

      this.formObj.patchValue({
        role: role,
        serviceVertical: serviceVertical,
        employee: user,
      });

      formGroupEdit = this.fb.group({
        id: [budgetDetail.id],
        role: [role],
        serviceVertical: [serviceVertical],
        user: [user],
        partner: [modalObj.assignedPartner],
        assignment: [modalObj.assignment],
        standardRate: [budgetDetail.standardRate],
        budgetedDays: [budgetDetail.budgetedDays],
        count: [budgetDetail.count],
        financialYear: [modalObj.financialYear]
      });

      (<FormArray>this.formObj.get('budgetDetails')).push(formGroupEdit);
    } else {
      // this.OrganizationSetupService.getEmployeesForRoles(role.id).subscribe(
      //   (res) => {
      this.OrganizationSetupService.getEmployeesForServiceVerticalAndRoles(budgetDetail.serviceVertical.id, budgetDetail.role.id).subscribe(
        (res) => {
          console.log('res', res);
          this.employeeList = res;
          employeeIndex = this.employeeList.findIndex(
            (item) => item.id == budgetDetail.user.id
          );
          for (let i = 0; i < this.employeeList.length; i++) {
            if (employeeIndex == i) {
              user = this.employeeList[i];
            }
          }
          console.log('user', user);
          this.formObj.patchValue({
            role: role,
            serviceVertical: serviceVertical,
            employee: user,
          });

          formGroupEdit = this.fb.group({
            id: [budgetDetail.id],
            role: [role],
            serviceVertical: [serviceVertical],
            user: [user],
            partner: [modalObj.assignedPartner],
            assignment: [modalObj.assignment],
            standardRate: [budgetDetail.standardRate],
            budgetedDays: [budgetDetail.budgetedDays],
            count: [budgetDetail.count],
            financialYear: [modalObj.financialYear]
          });

          (<FormArray>this.formObj.get('budgetDetails')).push(formGroupEdit);
        }
      );
    }
  }

  addBudgetBtnClick() {
    console.log(this.formObj.value);
    console.log(this.formObj.value.financialYear);
    console.log(this.formObj.value.assignedPartner);
    console.log(this.formObj.value.assignment);
    console.log(this.formObj.value.role);
    console.log(this.formObj.value.employee);
    console.log(this.formObj.value.assignmentFees)
    if (this.formObj.value.financialYear == null || this.formObj.value.financialYear == 'null' ||
      this.formObj.value.assignedPartner == null || this.formObj.value.assignedPartner == 'null' ||
      this.formObj.value.assignment == null || this.formObj.value.assignment == 'null' ||
      this.formObj.value.role == null || this.formObj.value.role == 'null' ||
      this.formObj.value.employee == null || this.formObj.value.employee == 'null' ||
      this.formObj.value.assignmentFees == null || this.formObj.value.assignmentFees == 'null' || this.formObj.value.assignmentFees == "") {
      this.commonMessageService.swalAlertWithoutIcon('', 'Some fields are missing please check before add budget.');
    }
    else {
      console.log("in else")
      // this.loadStandardRate();
      this.loadStandardRateByServiceVertical();
    }
  }

  // loadStandardRate() {

  //   this.OrganizationSetupService.getStandardRate(
  //     this.formObj.value.financialYear.id,
  //     this.formObj.value.branch.id,
  //     this.formObj.value.role.id
  //   ).subscribe((resp) => {
  //     console.log('standard rate: ', resp);
  //     this.loadUserDetails(resp);
  //     /*  this.addBudget(resp); */
  //   });
  // }

  loadStandardRateByServiceVertical() {
    if (this.formObj.value.serviceVertical == null || this.formObj.value.serviceVertical == 'undefined') {
      this.OrganizationSetupService.getStandardRate(
        this.formObj.value.financialYear.id,
        this.formObj.value.branch.id,
        this.formObj.value.role.id
      ).subscribe((resp) => {
        console.log('standard rate: ', resp);
        this.loadUserDetails(resp);
        /*  this.addBudget(resp); */
      });
    } else {
      this.OrganizationSetupService.getStandardRateByServiceVertical(
        this.formObj.value.financialYear.id,
        this.formObj.value.branch.id,
        this.formObj.value.serviceVertical?.id ?? null,
        this.formObj.value.role.id
      ).subscribe((resp) => {
        console.log('standard rate: ', resp);
        this.loadUserDetails(resp);
        /*  this.addBudget(resp); */
      });
    }
  }

  loadUserDetails(standardRate) {
    this.humanResourceService
      .viewProfile(this.formObj.get('employee').value.userId)
      .subscribe((resp) => {
        console.log('View profile: ', resp);
        this.addBudget(standardRate);
      });
  }

  addBudget(standardRate) {
    console.log('on add budget click budget details', this.formObj.get('budgetDetails'));
    console.log(this.formObj.value.employee);
    const budget_details = (<FormArray>this.formObj.get('budgetDetails')).value;
    var found = false;
    if (budget_details && budget_details.length > 0) {
      /* const found_match = budget_details.find(el => el.user.userId === this.formObj.value.employee.userId)

      if (found_match?.role?.id && found_match.role.id === standardRate.role.id) {
        console.log('Found match: ', found_match)
        this.commonMessageService.swalAlertWithoutIcon('','Already in this list.')
      } */
      for (let i = 0; i < this.formObj.controls.budgetDetails.length; i++) {
        if (
          this.formObj.controls.budgetDetails.value[i].user.id ==
          this.formObj.value.employee.id &&
          this.formObj.controls.budgetDetails.value[i].role.id ==
          this.formObj.value.role.id &&
          this.formObj.controls.budgetDetails.value[i].partner.id ==
          this.formObj.value.assignedPartner.id &&
          this.formObj.controls.budgetDetails.value[i].assignment.id ==
          this.formObj.value.assignment.id &&
          this.formObj.controls.budgetDetails.value[i].financialYear.id ==
          this.formObj.value.financialYear.id
        ) {
          console.log('found');
          found = true;
        }
      }
      if (found) {
        console.log('Found match: ');
        this.commonMessageService.swalAlertWithoutIcon('', 'Already in this list.');
      } else {
        console.log('Not found: ');

        (<FormArray>this.formObj.get('budgetDetails')).push(
          this.initBudgetDetails(standardRate)
        );
        this.setAssignmentValue();
      }
    } else {
      console.log('Budget details here: ', budget_details);
      (<FormArray>this.formObj.get('budgetDetails')).push(
        this.initBudgetDetails(standardRate)
      );
      this.setAssignmentValue();
    }
    console.log('budget details after adding budget', this.formObj);
  }

  initBudgetDetails(standardRate) {
    console.log(this.formObj.value.assignedPartner);
    return this.fb.group({
      id: [''],
      role: [this.formObj.get('role').value],
      serviceVertical: [this.formObj.get('serviceVertical').value],
      user: [this.formObj.value.employee],
      partner: [this.formObj.value.assignedPartner],
      assignment: [this.formObj.value.assignment],
      assignmentFees: [this.formObj.value.assignmentFees],
      standardRate: [standardRate.rate, Validators.required],
      budgetedDays: [0, Validators.required],
      count: [1, Validators.required],
      financialYear: [this.formObj.value.financialYear]
      // fromDate: [null, Validators.required],
      // toDate: [null, Validators.required],
    });
  }

  setAssignmentValue() {
    for (let i = 0; i < this.formObj.controls.budgetDetails.length; i++) {
      if (
        this.formObj.value.assignedPartner.id ==
        this.formObj.controls.budgetDetails.value[i].partner.id &&
        this.formObj.value.assignment.id ==
        this.formObj.controls.budgetDetails.value[i].assignment.id
      ) {
        console.log(
          'set Assignemnt',
          this.formObj.controls.budgetDetails.value[i]
        );
        this.formObj.controls.budgetDetails.value[
          i
        ].assignmentFees = this.formObj.value.assignmentFees;
        /* this.formObj.controls.budgetDetails.value[i].patchValue({
            assignmentFees : this.formObj.value.assignmentFees
          }) */
      }
    }
  }
  getTotalCost() {
    var cost = 0;
    this.formObj.value.budgetDetails.forEach((element) => {
      cost = cost + element.standardRate * element.count * element.budgetedDays;
    });
    return cost;
  }
  /*  checkIfBudgetExist(){
    var yearId = this.budgetForm.value.financialYear.id,
        branchId =  this.budgetForm.value.branch.id,
        partnerId = this.budgetForm.value.assignedPartner.id,
        clientId = this.budgetForm.value.client.id,
        assignmentId = this.budgetForm.value.assignment.id;

      this.OrganizationSetupService.getExistingBudget(yearId,branchId,partnerId,clientId,assignmentId)
        .subscribe((res:any) => {
          console.log(res);
          if(res.budgetDetails.length>0){
            this.budgetExist = res;
            this.formStatus = "edit";
            this.setValueToModalForm(res);
          }
      });
    }

     setValueToModalForm(modalObj) {
        console.log("resetOnBranchChange")
        this.budgetForm.patchValue({
          id:modalObj.id,
          assignmentFees: modalObj.assignmentFees,
        });
        this.budgetForm.controls['budgetDetails'].clear();
        modalObj.budgetDetails.forEach((element, key) => {
          this.addBudgetDetailFormGroupInEdit(element);
        })
     }

    addBudgetDetailFormGroupInEdit(budgetDetail) {
      // var fromDate1 = new Date(budgetDetail.fromDate);
      // var fromDate2 = moment(fromDate1, 'YYYY/MM/DD');
      // var fromDate = {year:parseInt(fromDate2.format('YYYY')),month:parseInt(fromDate2.format('M')),day:parseInt(fromDate2.format('D'))};
      // var toDate1 = new Date(budgetDetail.toDate);
      // var toDate2 = moment(toDate1, 'YYYY/MM/DD');
      // var toDate = {year:parseInt(toDate2.format('YYYY')),month:parseInt(toDate2.format('M')),day:parseInt(toDate2.format('D'))};

      let formGroup  = this.fb.group({
          id: [budgetDetail.id],
          role: [budgetDetail.role],
          user: [budgetDetail.user],
          standardRate: [budgetDetail.standardRate, Validators.required],
          budgetedDays: [budgetDetail.budgetedDays, Validators.required],
          count: [budgetDetail.count, Validators.required],
          // fromDate: [fromDate, Validators.required],
          // toDate: [toDate, Validators.required],
      });

      (<FormArray>this.budgetForm.get('budgetDetails')).push(formGroup);

    } */

  loadCities(value) {
    if (value != "null") {
      this.masterDataService.getCities(value.id).subscribe((res) => {
        console.log(res);
        this.clientCityList = res;
      });
    }
  }

  loadPostcode(value) {
    if (value != "null") {
      this.masterDataService.getPostcode(value.id).subscribe((res) => {
        console.log(res);
        this.clientPostcodeList = res;
      });
    }
  }

  loadCitiesForLocation(value, index) {
    if (value != "null") {
      this.masterDataService.getCities(value.id).subscribe((res) => {
        console.log(res);
        this.locationCityList[index] = res;
        this.locationCityListEnable[index] = true;
        this.locationPostCodeListEnable[index] = true;
      });
    }

  }

  loadPostcodeForLocation(value, index) {
    if (value != "null") {
      this.masterDataService.getPostcode(value.id).subscribe((res) => {
        console.log(res);
        this.locationPostCodeList[index] = res;
      });
    }
  }

  // -----------------------------------------

  enableClientCity() {
    var stateId = this.formObj.value.state.id;
    this.formObj.patchValue({ city: null });
    this.masterDataService.getCities(stateId).subscribe((res) => {
      console.log(res);
      this.clientCityList = res;
      this.showClientCity = true;
    });
  }

  enableClientPostCode() {
    var cityId = this.formObj.value.city.id;
    this.formObj.patchValue({ postCode: null });
    this.masterDataService.getPostcode(cityId).subscribe((res) => {
      console.log(res);
      this.clientPostcodeList = res;
      this.showClientPostCode = true;
    });
  }

  enableLocationCity(value, index) {
    var arrayControl = this.formObj.get('clientLocations') as FormArray;
    var item = arrayControl.at(index) as FormGroup;
    item.patchValue({ city: null });
    this.masterDataService.getCities(value.id).subscribe((res) => {
      console.log(res);
      this.locationCityList[index] = res;
      this.locationCityListEnable[index] = true;
    });
  }

  enableLocationPostCode(value, index) {
    var arrayControl = this.formObj.get('clientLocations') as FormArray;
    var item = arrayControl.at(index) as FormGroup;
    item.patchValue({ postCode: null });
    this.masterDataService.getPostcode(value.id).subscribe((res) => {
      console.log(res);
      this.locationPostCodeList[index] = res;
      this.locationPostCodeListEnable[index] = true;
    });
  }

  // -----------------------------------------

  // @ViewChild('instance', { static: true }) instance: NgbTypeahead;
  // focus$ = new Subject<string>();
  // click$ = new Subject<string>();

  // search = (text$: Observable<string>) => {
  //   const debouncedText$ = text$.pipe(
  //     debounceTime(200),
  //     distinctUntilChanged()
  //   );
  //   const clicksWithClosedPopup$ = this.click$.pipe(
  //     filter(() => !this.instance.isPopupOpen())
  //   );
  //   const inputFocus$ = this.focus$;

  //   return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(
  //     map((term) =>
  //       (term === ''
  //         ? this.clientPostcodeList
  //         : this.clientPostcodeList.filter(
  //             (v) => v.toLowerCase().indexOf(term.toLowerCase()) > -1
  //           )
  //       ).slice(0, 10)
  //     )
  //   );
  // };
  //-------------------------------------------------------------------

  // Main Modal Action
  openModal(status) {
    this.formStatus = status;
    this.formObj.patchValue({
      signDate: [new Date()],
    });

    if (this.formStatus === 'edit') {
      this.showNextButton = false;
    } else {
      this.editGlobalResponse = null;
      console.log("this.financialYearList", this.financialYearList[0].endDate)
      console.log("clientEmail", this.formObj.get('clientEmails'))
      this.globalMaxDate = null
      var maxDate = new Date(this.financialYearList[0].endDate);
      var maxDate1 = moment(maxDate, 'YYYY/MM/DD');
      this.globalMaxDate = {
        year: parseInt(maxDate1.format('YYYY')),
        month: parseInt(maxDate1.format('M')),
        day: parseInt(maxDate1.format('D')),
      };
      this.resetModalForm();
      this.formObj.patchValue({
        signDate: [new Date()],
      });
      this.formObj.controls['clientEmails'].clear();
      this.formObj.controls['partners'].clear();
      (<FormArray>this.formObj.get('partners')).push(this.addPartnerFormGroup());
      (<FormArray>this.formObj.get('clientEmails')).push(this.addEmailFormGroup());
      (<FormArray>this.formObj.get('clientEmails')).push(this.addEmailFormGroup());
      (<FormArray>this.formObj.get('clientEmails')).push(this.addEmailFormGroup());
      this.showNextButton = true;
    }
    this.modalService
      .open(this.modalContent, {
        ariaLabelledBy: 'modal-basic-title',
        size: 'xxl',
        backdrop: 'static',
        windowClass: 'animate__animated animate__slideInUp animate__faster',
      })
      .result.then(
        (result) => { },
        (reason) => { }
      );
  }

  exportToExcelReport() {
    this.masterDataService
      .getClientExportToExcel().subscribe((resp: any) => {
        const blob = new Blob([resp]); // you can change the type
        var downloadURL = window.URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = downloadURL;
        link.download = "ClientReport.xlsx";
        link.click();
      });
  }

  closeModal(formStatus, status) {
    if (formStatus == 'add') {
      console.log('in close');
      if (status == 'success') {
        console.log('in close Success');
        this.resetModalForm();
        this.modalService.dismissAll();
      } else {
        console.log('in alret Success');
        this.resetModalForm();
        this.modalService.dismissAll();
        this.commonMessageService.swalAlertWithoutIcon('',
          'You will not able to save the client,Also form data will be lost...!'
        );
      }
    } else if (formStatus == 'edit') {
      if (status == 'success') {
        this.resetModalForm();
        this.modalService.dismissAll();
      } else {
        this.resetModalForm();
        this.modalService.dismissAll();
        this.commonMessageService.swalAlertWithoutIcon('', 'You will not able to update the client');
      }
    }
  }

  resetModalForm() {
    this.locationCityList = [];
    this.locationPostCodeList = [];
    this.locationCityListEnable = [];
    this.locationPostCodeListEnable = [];
    this.showChecklist = false;
    this.showClientBudget = false;
    this.formSubmitted = false;
    this.showClientCity = false;
    this.showClientPostCode = false;
    this.formObj.reset();
    /* this.formObj.controls['partners'].clear(); */
    this.formObj.controls['clientLocations'].clear();
    this.formObj.controls['budgetDetails'].clear();
    this.resetClientCheckList();
    this.formObj.get('isSign').clearValidators();
    this.formObj.controls['isSign'].updateValueAndValidity();
    //this.editGlobalResponse = null;
  }

  resetClientCheckList() {
    this.removeValidationFromAcceptance();
    var arrayControl = this.formObj.get('clientCheckList') as FormArray;
    this.checkList.forEach((checklist, key) => {
      var item1 = arrayControl.at(key) as FormGroup;
      item1.patchValue({
        id: '',
        questionId: checklist.id,
        questionNo: checklist.questionNo,
        question: checklist.question,
        isRequired: checklist.isRequired,
        remark: checklist.remark,
      });
      console.log(this.formObj);
    });
  }

  compareItems(i1, i2) {
    return i1 && i2 && i1.id === i2.id;
  }
  // Assignments

  newCheckPartnerArrayEqualsOrNot() {
    console.log("budget", this.editGlobalResponse)
    console.log("assignments", this.formObj.controls.partners)

    return true;
  }

  changesInAssignments() {
    console.log('budget', this.editGlobalResponse)
    if (this.formStatus == 'edit') {
      var isNotEqual = this.checkPartnerArrayEqualsOrNot();
      if (isNotEqual) {
        this.showNextButton = true;
      } else {
        this.showNextButton = false;
      }
    }

  }

  blurCheck = false;
  onToDateChange(index) {
    var lastPartnerIndex = this.formObj.controls.partners.length - 1;
    if (lastPartnerIndex == index) {
      var fromDate = new Date(this.formObj.controls.partners.value[index].fromDate.year + '-' + this.formObj.controls.partners.value[index].fromDate.month + '-' + this.formObj.controls.partners.value[index].fromDate.day)
      var toDate = new Date(this.formObj.controls.partners.value[index].toDate.year + '-' + this.formObj.controls.partners.value[index].toDate.month + '-' + this.formObj.controls.partners.value[index].toDate.day)
      var formattedFromDate = moment(fromDate).format('YYYY-MM-DD')
      var formattedToDate = moment(toDate).format('YYYY-MM-DD')
      var currentPartner = this.formObj.controls.partners.value[index].id;
      console.log("formattedFromDate", formattedFromDate)
      // console.log("formattedToDate",formattedToDate)
      console.log("Partner", currentPartner);

      var currentTime = new Date();
      var currentYear = currentTime.getFullYear() + 1;
      var currentFYDate = currentYear + '-03-31';
      console.log('current date', currentFYDate);
      console.log('formatted to date', formattedToDate);
      if (formattedToDate > currentFYDate) {
        this.commonMessageService.swalAlertWithoutIcon('', "Please select year till current financial year");
        this.formObj.controls.partners.controls[index].patchValue({
          toDate: ""
        });
      }

      var isValid = false;
      for (let i = 0; i < this.formObj.controls.partners.length - 1; i++) {
        if (this.formObj.controls.partners.value[i].id == currentPartner) {
          var existPartnerFromDate = new Date(this.formObj.controls.partners.value[i].fromDate.year + '-' + this.formObj.controls.partners.value[i].fromDate.month + '-' + this.formObj.controls.partners.value[i].fromDate.day);
          var existPartnerToDate = new Date(this.formObj.controls.partners.value[i].toDate.year + '-' + this.formObj.controls.partners.value[i].toDate.month + '-' + this.formObj.controls.partners.value[i].toDate.day)
          var formattedExistPartnerFromDate = moment(existPartnerFromDate).format('YYYY-MM-DD')
          var formattedExistPartnerToDate = moment(existPartnerToDate).format('YYYY-MM-DD')
          console.log('formattedFromDate', formattedFromDate);
          console.log('formattedExistPartnerToDate', formattedExistPartnerToDate);
          // if(formattedFromDate<=formattedExistPartnerToDate){
          //   isValid=true;
          // }
          if ((formattedFromDate >= formattedExistPartnerFromDate) && (formattedExistPartnerToDate >= formattedToDate)) {
            isValid = true;
          } else if (formattedFromDate >= formattedExistPartnerFromDate && formattedExistPartnerToDate >= formattedFromDate) {
            isValid = true;
          } else if (formattedToDate >= formattedExistPartnerFromDate && formattedExistPartnerToDate >= formattedFromDate) {
            isValid = true;
          }
        }
      }

      if (isValid) {
        this.commonMessageService.swalAlertWithoutIcon('', "assignments list for same partner for current financial year is already created if you want to enter assignment for current financial year please increase the date limit of same partner....")
        this.formObj.controls.partners.controls[index].patchValue({
          fromDate: "",
          toDate: ""
        });
      }
    }
    // if ((fromDate >= fromDate1) && (toDate1 >= toDate)) {
    //   //   isValid = true;
    //   // } else if (fromDate >= fromDate1 && toDate1 >= fromDate) {
    //   //   isValid = true;
    //   // } else if (toDate >= fromDate1 && toDate1 >= fromDate) {
    //   //   isValid = true;
    //   // }
    // var isValid = false
    // var financialYearId = ""
    // for(let i=0;i<this.financialYearList.length;i++){
    //   if(formattedFromDate >= this.financialYearList[i].startDate && formattedToDate <= this.financialYearList[i].endDate){
    //     financialYearId = this.financialYearList[i].id
    //   }
    // }
    // console.log('financialYearId', financialYearId);
    // for(let i=0;i<this.formObj.controls.partners.value.length-1;i++){
    //   var fromDate1=new Date(this.formObj.controls.partners.value[i].fromDate.year + '-' + this.formObj.controls.partners.value[i].fromDate.month + '-' + this.formObj.controls.partners.value[i].fromDate.day)
    //   var toDate1=new Date(this.formObj.controls.partners.value[i].toDate.year + '-' + this.formObj.controls.partners.value[i].toDate.month + '-' + this.formObj.controls.partners.value[i].toDate.day)
    //   var formattedFromDate1 = moment(fromDate1).format('YYYY-MM-DD')
    //   var formattedToDate1 =moment(toDate1).format('YYYY-MM-DD')
    //   // if(this.formObj.controls.partners.value[index].id == this.formObj.controls.partners.value[i].id){
    //   // if ((fromDate >= fromDate1) && (toDate1 >= toDate)) {
    //   //   isValid = true;
    //   // } else if (fromDate >= fromDate1 && toDate1 >= fromDate) {
    //   //   isValid = true;
    //   // } else if (toDate >= fromDate1 && toDate1 >= fromDate) {
    //   //   isValid = true;
    //   // }
    //   var financialYearId1 = ""
    //   for(let i=0;i<this.financialYearList.length;i++){
    //     if(formattedFromDate1 >= this.financialYearList[i].startDate && formattedToDate1 <= this.financialYearList[i].endDate){
    //       financialYearId1 = this.financialYearList[i].id
    //     }
    //   }
    //   console.log('financialYearId1', financialYearId1);
    //   if(financialYearId == financialYearId1 && this.formObj.controls.partners.value[i].id == this.formObj.controls.partners.value[index].id){
    //     if(index == this.formObj.controls.partners.value.length-1 && this.formObj.controls.partners.value.length>1)
    //     isValid = true;
    //   }

    // }

    // console.log("isValid", isValid)
    // if(isValid){
    //  this.commonMessageService.swalAlertWithoutIcon('',"assignments list for same partner for current financial year is already created if you want to enter assignment for current financial year please increase the date limit of same partner....")
    //   this.formObj.controls.partners.controls[index].patchValue({
    //     fromDate : "",
    //     toDate : ""
    //   })
    // }
  }


  onAssignmentChange(partner, assignment, index, item) {

    if (this.formStatus == 'edit') {
      if (this.editGlobalResponse != null || this.editGlobalResponse != undefined) {
        console.log('for client id', this.editGlobalResponse);
        console.log("patner", partner);
        console.log("assignement", assignment)
        console.log("editGlobalResponse..", this.editGlobalResponse)
        var fromDate = new Date(partner.value.fromDate.year + '-' + partner.value.fromDate.month + '-' + partner.value.fromDate.day)
        var toDate = new Date(partner.value.toDate.year + '-' + partner.value.toDate.month + '-' + partner.value.toDate.day)
        var formattedFromDate = moment(fromDate).format('YYYY-MM-DD')
        var formattedToDate = moment(toDate).format('YYYY-MM-DD')
        var financialYearId = []
        var finacialyearStartDateId = ''
        var finacialyearEndDateId = ''
        var checkDiaryForBudget
        if (!item._selected) {
          this.masterDataService.checkDiaryExistForBudget(this.editGlobalResponse.client.id, assignment.id, formattedFromDate, formattedToDate).subscribe((res: any) => {
            checkDiaryForBudget = res;
            console.log('checkDiaryForBudget', checkDiaryForBudget);
            if (checkDiaryForBudget) {
              console.log('inside if');
              this.commonMessageService.swalAlertWithoutIcon('', 'Diary filled for this assignment so you cannot delete.')
              this.closeModal('edit', 'success');
              this.onEditClick(this.selectedForm);
            } else {
              for (let i = 0; i < this.financialYearList.length; i++) {
                if (formattedFromDate >= this.financialYearList[i].startDate) {
                  if (finacialyearStartDateId == '') {
                    finacialyearStartDateId = this.financialYearList[i].id
                  }
                } if (formattedToDate <= this.financialYearList[i].endDate) {
                  finacialyearEndDateId = this.financialYearList[i].id
                }
              }
              for (let i = 0; i < this.financialYearList.length; i++) {
                if (this.financialYearList[i].id <= finacialyearEndDateId && this.financialYearList[i].id >= finacialyearStartDateId) {
                  financialYearId.push(this.financialYearList[i])
                }
              }
              var budgetExist = false
              var deleteBudgetIndex = []
              for (let i = 0; i < this.editGlobalResponse.budget.length; i++) {
                if (this.editGlobalResponse.budget[i].assignment != null) {
                  if (this.editGlobalResponse.budget[i].assignedPartner.id == partner.value.id
                    && this.editGlobalResponse.budget[i].assignment.id == assignment.id) {
                    for (let k = 0; k < financialYearId.length; k++) {
                      if (financialYearId[k].id == this.editGlobalResponse.budget[i].financialYear.id) {
                        budgetExist = true
                        deleteBudgetIndex.push(this.editGlobalResponse.budget[i])

                      }
                    }
                  }
                }
              }
              console.log('before if condition', budgetExist);
              if (budgetExist) {
                console.log('Partner Details', partner);
                // var result = confirm('Budget for ' + assignment.name + ' is created,this action will delete its budget for financial years');
                var result = Swal.fire({
                  text: 'Budget for ' + assignment.name + ' is created,this action will delete its budget for financial years',
                  showCancelButton: true,
                  confirmButtonText: 'Ok',
                  confirmButtonColor: '#800000'
                }).then((result) => { })

                if (result) {
                  this.blurCheck = true;
                  for (let i = 0; i < deleteBudgetIndex.length; i++) {
                    const index = this.editGlobalResponse.budget.indexOf(deleteBudgetIndex[i]);
                    if (index > -1) {
                      this.editGlobalResponse.budget.splice(index, 1);
                    }
                  }
                  console.log('budget delete on edit click', this.editGlobalResponse);
                }

                else {
                  this.blurCheck = false;
                  this.formObj.controls.partners.value[index].assignments.push(assignment);
                  console.log('updated ass list', this.formObj.controls.partners.value[index]);
                  this.closeModal('edit', 'success');
                  console.log('formObj', this.selectedForm);
                  this.onEditClick(this.selectedForm);
                }
              }
              for (let i = 0; i < this.editGlobalResponse.client.partners.length; i++) {
                if (this.editGlobalResponse.client.partners[i].id == partner.value.id
                  && this.editGlobalResponse.client.partners[i].assignment.id == assignment.id
                  && this.editGlobalResponse.client.partners[i].fromDate == formattedFromDate &&
                  this.editGlobalResponse.client.partners[i].toDate == formattedToDate) {
                  console.log('before client assignment splice', this.editGlobalResponse.client.partners);
                  this.editGlobalResponse.client.partners.splice(i, 1);
                  console.log('after client assignment splice', this.editGlobalResponse.client.partners);
                }
              }
            }
            // this.checkBudgetForAssignment();
          });
        } else { }
      }
    }
  }

  // ADD PARTNER
  addPartnerButtonClick() {
    this.disableDateOnPartnerChange = false;
    (<FormArray>this.formObj.get('partners')).push(this.addPartnerFormGroup());
    if (this.formStatus == 'add') {
      this.showNextButton = true;
    } else {
      var isNotEqual = this.checkPartnerArrayEqualsOrNot();
      if (isNotEqual) {
        this.showNextButton = true;
      }
    }


    //  else {
    //   if (this.formStatus == 'add') {
    //     this.showNextButton = true;
    //   } else {
    //     this.showNextButton = false;
    //   }
    // }
  }

  addPartnerFormGroup(): FormGroup {
    return this.fb.group({
      id: ['', Validators.required],
      assignments: ['', Validators.required],
      fromDate: ['', Validators.required],
      toDate: ['', Validators.required],
    });
  }

  addEmailFormGroup(): FormGroup {
    return this.fb.group({
      id: [0],
      email: ['']
    });
  }

  removePartnerButtonClick(partner, index, formobject) {
    console.log('formObject value', formobject)
    console.log("parnter value for remove", partner.value, 'index', index)
    var checkDiaryForBudget;

    if (this.formStatus == 'edit') {
      if (index > this.selectedPartnerList.length - 1) {
        console.log('inside if');
        const formArray = <FormArray>this.formObj.get('partners');
        formArray.removeAt(index);
      } else {
        console.log('inside else');
        Swal.fire({
          text: 'Are you sure you want to remove?',
          showCancelButton: true,

          confirmButtonText: 'Ok',
          confirmButtonColor: '#800000'
        }).then((result) => {
          if (result.isConfirmed) {
            var fromDate = new Date(partner.value.fromDate.year + '-' + partner.value.fromDate.month + '-' + partner.value.fromDate.day)
            var toDate = new Date(partner.value.toDate.year + '-' + partner.value.toDate.month + '-' + partner.value.toDate.day)
            var formattedFromDate = moment(fromDate).format('YYYY-MM-DD')
            var formattedToDate = moment(toDate).format('YYYY-MM-DD')
            var assignmentId = partner.value.assignments.map(({ id }) => id);
            console.log('assignment list', partner.value.assignments);
            console.log('assignment id', assignmentId);

            var fy;
            for (let j = 0; j < this.financialYearList.length; j++) {
              if (formattedToDate <= this.financialYearList[j].endDate || formattedFromDate <= this.financialYearList[j].startDate) {
                fy = this.financialYearList[j]
              }
            }

            console.log('checkfy', fy);

            console.log('all details', this.editGlobalResponse.client.id, formattedFromDate, formattedToDate);
            this.masterDataService.checkDiaryExistForBudget(this.editGlobalResponse.client.id, assignmentId, formattedFromDate, formattedToDate).subscribe((res: any) => {
              checkDiaryForBudget = res;
              console.log('response of diary check', checkDiaryForBudget);
              console.log('editglobalresponse', this.editGlobalResponse);

              if (checkDiaryForBudget) {
                // for (let j = 0; j < partner.value.assignments.length; j++) {
                //  this.commonMessageService.swalAlertWithoutIcon('','Can not delete because diary exist for this ' + partner.value.assignments[j].name + ' assignment');
                // }
                this.commonMessageService.swalAlertWithoutIcon('', 'Can not delete because diary exist for this assignment');
              } else {
                console.log('inside else');
                for (let i = 0; i < this.editGlobalResponse.client.partners.length; i++) {
                  for (let j = 0; j < partner.value.assignments.length; j++) {
                    if (this.editGlobalResponse.client.partners[i].id == partner.value.id &&
                      this.editGlobalResponse.client.partners[i].fromDate == formattedFromDate &&
                      this.editGlobalResponse.client.partners[i].toDate == formattedToDate
                      && this.editGlobalResponse.client.partners[i].assignment.id == partner.value.assignments[j].id
                    ) {
                      console.log('inside if', index, i);
                      console.log('before client assignment splice', this.editGlobalResponse.client.partners);
                      this.editGlobalResponse.client.partners.splice(i, 1);
                      console.log('after client assignment splice', this.editGlobalResponse.client.partners);
                    }
                  }
                }

                for (let i = 0; i < this.editGlobalResponse.budget.length; i++) {
                  for (let j = 0; j < partner.value.assignments.length; j++) {
                    console.log('inside if of budget', this.editGlobalResponse.budget);
                    if (this.editGlobalResponse.budget[i].assignedPartner.id == partner.value.id &&
                      this.editGlobalResponse.budget[i].assignment.id == partner.value.assignments[j].id &&
                      this.editGlobalResponse.budget[i].financialYear.name == fy.name
                    ) {
                      console.log('inside if of budget', this.editGlobalResponse.budget[i]);
                      console.log('before client assignment splice', this.editGlobalResponse.budget);
                      this.editGlobalResponse.budget.splice(i, 1)
                      console.log('after client assignment splice', this.editGlobalResponse.budget);
                    }
                  }
                }

                const formArray = <FormArray>this.formObj.get('partners');
                formArray.removeAt(index);
                // formArray.markAsDirty();
                // formArray.markAsTouched();
              }
              console.log('editglobalresponse', this.editGlobalResponse);
            });
          }
        })

      }
    }


    // var partnerBudgetExist = false
    // if (this.formStatus == 'edit' && index <= this.selectedPartnerList.length - 1) {
    //   if (this.editGlobalResponse != null || this.editGlobalResponse != undefined) {
    //     for (let i = 0; i < this.editGlobalResponse.budget.length; i++) {
    //       if (this.editGlobalResponse.budget[i].assignedPartner.id == this.selectedPartnerList[index].id) {
    //         partnerBudgetExist = true
    //       }
    //     }
    //   }
    // }

    // if (partnerBudgetExist) {
    //  this.commonMessageService.swalAlertWithoutIcon('',"Cannot delete this partner as budget is created ...!")
    // } else {
    //   const formArray = <FormArray>this.formObj.get('partners');
    //   formArray.removeAt(index);
    //   formArray.markAsDirty();
    //   formArray.markAsTouched();
    // }



    // var result=confirm("Buy deleting this partner you will delete all assignment budget for this....!")
    // if(result){
    //   if(this.formStatus=='edit'){
    //   if (this.editGlobalResponse != null || this.editGlobalResponse != undefined) {

    //   var fromDate=new Date(this.formObj.controls.partners[index].value.fromDate.year + '-' + this.formObj.controls.partners[index].value.fromDate.month + '-' + this.formObj.controls.partners[index].value.fromDate.day)
    //   var toDate=new Date(this.formObj.controls.partners[index].value.toDate.year + '-' + this.formObj.controls.partners[index].value.toDate.month + '-' + this.formObj.controls.partners[index].value.toDate.day)
    //   var formattedFromDate = moment(fromDate).format('YYYY-MM-DD')
    //   var formattedToDate =moment(toDate).format('YYYY-MM-DD')
    //   console.log("formattedFromDate",formattedFromDate)
    //   console.log("formattedToDate",formattedToDate)
    //   var financialYearId = []
    //   var finacialyearStartDateId = ''
    //   var finacialyearEndDateId = ''
    //   for(let i=0;i<this.financialYearList.length;i++){
    //     if(formattedFromDate >= this.financialYearList[i].startDate){
    //       if(finacialyearStartDateId ==  ''){
    //       finacialyearStartDateId = this.financialYearList[i].id
    //       }
    //     }if(formattedToDate <= this.financialYearList[i].endDate){
    //       finacialyearEndDateId = this.financialYearList[i].id
    //     }
    //   }
    //   console.log('finacialyearStartDateId', finacialyearStartDateId);
    //   console.log('finacialyearEndDateId', finacialyearEndDateId);
    //   for(let i=0;i<this.financialYearList.length;i++){
    //     if(this.financialYearList[i].id <= finacialyearEndDateId && this.financialYearList[i].id >=finacialyearStartDateId){
    //       financialYearId.push(this.financialYearList[i])
    //     }
    //   }
    //   console.log('finacialyearEndDateIds', financialYearId);
    //   console.log('editGlobalResponse', this.editGlobalResponse);

    //       for(let i=0;i<this.editGlobalResponse.client.partners.length;i++){
    //         if (this.editGlobalResponse.client.partners[i].id == this.formObj.controls.partners[index].value.id
    //           && this.editGlobalResponse.client.partners[i].financialYear.id == finacialyearEndDateId) {
    //             this.editGlobalResponse.client.partners.splice(i, 1);
    //         }
    //       }

    //       for(let i = 0; i < deleteBudgetIndex.length; i++){
    //         const index = this.editGlobalResponse.budget.indexOf(deleteBudgetIndex[i]);
    //         if (index > -1) {
    //           this.editGlobalResponse.budget.splice(index, 1);
    //         }
    //       }

    //       console.log('budget', this.editGlobalResponse);
    //     }
    //   }
    // }
    //this.commonMessageService.swalAlertWithoutIcon('',"Not able to delete partner as budget is already created for some assignments")
    // const formArray = <FormArray>this.formObj.get('partners');
    // formArray.removeAt(index);
    // formArray.markAsDirty();
    // formArray.markAsTouched();
  }

  // ADD LOCATION
  addLocationButtonClick() {
    console.log('flength', this.formObj.controls.clientLocations.length);

    (<FormArray>this.formObj.get('clientLocations')).push(
      this.addClientLocationFormGroup()
    );
  }

  addClientLocationFormGroup(): FormGroup {
    this.locationCityList.push([]);
    this.locationPostCodeList.push([]);
    var index = this.formObj.value.clientLocations.length;
    if (index == 0) {
      this.locationCityList[0] = this.clientCityList;
      this.locationPostCodeList[0] = this.clientPostcodeList;
    } else {
      this.locationCityList[index + 1] = this.clientCityList;
      this.locationPostCodeList[index + 1] = this.clientPostcodeList;
      this.formObj.value.address = null;
      this.formObj.value.state = null;
      this.formObj.value.city = null;
      this.formObj.value.postCode = null;
    }
    return this.fb.group({
      id: [''],
      distance: [0, Validators.required],
      address: [this.formObj.value.address, [Validators.required]],
      state: [this.formObj.value.state, [Validators.required]],
      city: [this.formObj.value.city, [Validators.required]],
      postCode: [this.formObj.value.postCode, [Validators.required]],
    });
  }

  removeClientLocationButtonClick(index: number): void {
    const formArray = <FormArray>this.formObj.get('clientLocations');
    formArray.removeAt(index);
    formArray.markAsDirty();
    formArray.markAsTouched();
  }

  // -------------Prvious Assignment Validation Logic---------------
  // checkDurationValidity(dateObj1, dateObj2) {
  //   var isValid = true;
  //   var obj1FromDate = new Date(
  //     dateObj1.fromDate.year +
  //     '-' +
  //     dateObj1.fromDate.month +
  //     '-' +
  //     dateObj1.fromDate.day
  //   );
  //   var obj1ToDate = new Date(
  //     dateObj1.toDate.year +
  //     '-' +
  //     dateObj1.toDate.month +
  //     '-' +
  //     dateObj1.toDate.day
  //   );
  //   var obj2FromDate = new Date(
  //     dateObj2.fromDate.year +
  //     '-' +
  //     dateObj2.fromDate.month +
  //     '-' +
  //     dateObj2.fromDate.day
  //   );
  //   var obj2ToDate = new Date(
  //     dateObj2.toDate.year +
  //     '-' +
  //     dateObj2.toDate.month +
  //     '-' +
  //     dateObj2.toDate.day
  //   );
  //   console.log('obj2FromDate', obj2FromDate + ' ' + obj2ToDate);
  //   console.log('obj1FromDate', obj1FromDate + ' ' + obj1ToDate);
  //   if (obj2FromDate > obj1ToDate || obj2ToDate < obj1FromDate) {
  //   } else {
  //     isValid = false;
  //   }
  //   return isValid;
  // }

  // getCommonItems(array1, array2) {
  //   var common = []; // Initialize array to contain common items

  //   for (var i = 0; i < array1.length; i++) {
  //     for (var j = 0; j < array2.length; j++) {
  //       if (array1[i].id == array2[j].id) {
  //         // If item is present in both arrays
  //         common.push(array1[i]); // Push to common array
  //       }
  //     }
  //   }

  //   return common; // Return the common items
  // }

  // validateAssignment(){
  // this.formObj.value.partners.forEach((element, key) => {
  //   if (key < this.formObj.value.partners.length - 1) {
  //     var currentPartner = element;
  //     console.log('current', currentPartner);
  //     var nextPartner = this.formObj.value.partners[key + 1];
  //     console.log('nextpartner', nextPartner);
  //     // let intersection = currentPartner.assignments.filter((x) =>
  //     //   nextPartner.assignments.includes(x)
  //     // );
  //     let intersection = this.getCommonItems(
  //       currentPartner.assignments,
  //       nextPartner.assignments
  //     );
  //     console.log('intersectore assignment',intersection);
  //     if (intersection.length > 0) {
  //       var item1 = arrayControl.at(key) as FormGroup;
  //       var item2 = arrayControl.at(key + 1) as FormGroup;
  //       var isDurationValid = this.checkDurationValidity(
  //         item1.value,
  //         item2.value
  //       );
  //       if (!isDurationValid) {
  //         this.invalidPartnerAssignmentsList.push(key);
  //         this.invalidPartnerAssignmentsList.push(key + 1);
  //       }
  //     }
  //   }
  // });
  // }

  invalidPartnerAssignmentsList: any;
  validateAssignments() {
    this.invalidPartnerAssignmentsList = [];
    var arrayControl = this.formObj.get('partners') as FormArray;


    // for (const partner of this.formObj.value.partners) {
    //   // Check if there is no matching ID in partnerList
    //   if (!this.partnerList.some(p => p.id === partner.id)) {
    //     this.partnerFound = true;
    //     break; // Break the loop if a mismatch is found
    //   }
    // }


    for (let f = 0; f < this.formObj.value.partners.length; f++) {
      var fisrtPartner = this.formObj.value.partners[f];




      var firstFromDate = new Date(fisrtPartner.fromDate.year + '-' + fisrtPartner.fromDate.month + '-' + fisrtPartner.fromDate.day)
      var firstToDate = new Date(fisrtPartner.toDate.year + '-' + fisrtPartner.toDate.month + '-' + fisrtPartner.toDate.day)
      for (let s = f + 1; s < this.formObj.value.partners.length; s++) {
        var secondPartner = this.formObj.value.partners[s];



        var secondFromDate = new Date(secondPartner.fromDate.year + '-' + secondPartner.fromDate.month + '-' + secondPartner.fromDate.day)
        var secondToDate = new Date(secondPartner.toDate.year + '-' + secondPartner.toDate.month + '-' + secondPartner.toDate.day)
        for (let i = 0; i < fisrtPartner.assignments.length; i++) {
          for (let j = 0; j < secondPartner.assignments.length; j++) {
            if (fisrtPartner.assignments[i].name == secondPartner.assignments[j].name
              // secondFromDate>=firstFromDate &&
              //     secondFromDate<=firstToDate &&
              //     secondToDate>firstFromDate &&
              //     secondToDate<firstToDate
            ) {
              if (secondFromDate <= firstToDate && secondFromDate >= firstFromDate) {
                this.invalidPartnerAssignmentsList.push(f);
                this.invalidPartnerAssignmentsList.push(s);
                console.log('partner object', this.formObj.value.partners[f]);
              }
            }
          }
        }
      }
    }
    if (this.invalidPartnerAssignmentsList.length > 0) {
      this.invalidPartnerAssignmentsList.forEach((element, key) => {
        var item = arrayControl.at(element) as FormGroup;
        console.log('items', item);
        item.controls['assignments'].setErrors({ incorrect: true });
      });
    } else {
      this.formObj.value.partners.forEach((element, key) => {
        var item = arrayControl.at(key) as FormGroup;
        item.controls['assignments'].setErrors({ incorrect: null });
        item.controls['assignments'].updateValueAndValidity();
      });
      //  this.modalForm.controls["entryDate"].setErrors(null)
      this.formObj.controls['clientCheckList'].setErrors(null);
      console.log('this.formSubmitted', this.formSubmitted);
      if (this.formSubmitted) {
        //if(this.formStatus=='edit'){
        console.log('this.formObj', this.formObj);
        if (this.formObj.valid) {
          this.showChecklist = true;
        } //}
        else {
          this.showChecklist = false;
        }
        //this.showNextButton = false;
      }
    }
    if (this.showChecklist) {
      this.setValidationOnAcceptance();
    }
  }
  // -------  -----
  // Events
  setValidationOnAcceptance() {
    console.log('setValidationOnAcceptance');
    var arrayControl = this.formObj.get('clientCheckList') as FormArray;
    this.checkList.forEach((checklist, key) => {
      var item1 = arrayControl.at(key) as FormGroup;
      item1.get('remark').setValidators(Validators.required);
      item1.get('remark').updateValueAndValidity();
    });
    this.formObj.get('isSign').setValidators(Validators.required);
    this.formObj.get('isSign').updateValueAndValidity();
    console.log(this.formObj);
  }

  removeValidationFromAcceptance() {
    var arrayControl = this.formObj.get('clientCheckList') as FormArray;
    this.checkList.forEach((checklist, key) => {
      var item1 = arrayControl.at(key) as FormGroup;
      //  item1.get('remark').setErrors({ required: null });
      item1.get('remark').clearValidators();
      item1.get('remark').updateValueAndValidity();
    });
    // this.formObj.controls['isSign'].setErrors({ required: null });
    this.formObj.get('isSign').clearValidators();
    this.formObj.get('isSign').updateValueAndValidity();
  }
  showClientBudget = false;
  onNextBtnClick() {
    console.log('onnext click', this.formObj);
    window.scroll(0, 0);
    this.formSubmitted = true;
    this.logValidationErrors(this.formObj);
    this.loadFinancialYear();
    this.loadRoles();
    this.loadServiceVerticals();
    if (this.showChecklist) {
      if (this.formStatus == 'edit') {
        console.log('edit', this.formObj.controls);
        if (this.formObj.valid) {
          console.log('budgetDetails', this.formObj.controls.budgetDetails);
          // this.formObj.patchValue({
          //   assignmentFees: '0',
          // });
          this.setValidationOnAcceptance();
          this.loadAssignedPartnerList();
          this.loadFinancialYearListForBudget();
          this.loadAssignmentsListForCheckList();
          this.showChecklist = false;
          this.showClientBudget = true;
          this.showNextButton = false;
        }
      } else {
        if (this.formObj.valid) {
          console.log('budgetDetails', this.formObj.controls.budgetDetails);
          // this.formObj.patchValue({
          //   assignmentFees: '0',
          // });
          this.setValidationOnAcceptance();
          this.loadAssignedPartnerList();
          this.loadFinancialYearListForBudget();
          this.loadAssignmentsListForCheckList();
          this.showChecklist = false;
          this.showClientBudget = true;
          this.showNextButton = false;
        }
      }
    } else {
      console.log('in else');
      if (this.formObj.value.clientLocations.length > 0) {
        this.validateAssignments();
        this.loadAssignedPartnerList();
        this.loadFinancialYearListForBudget();
        this.loadAssignmentsListForCheckList();
      } else {
        this.commonMessageService.swalAlertWithoutIcon('', 'Please add location...!');
      }
    }
  }

  onBackBtnClick() {
    window.scroll(0, 0);
    if (this.showChecklist) {
      this.showChecklist = false;
      this.showNextButton = true;
      this.showClientBudget = false;
      this.removeValidationFromAcceptance();
    } else if (this.showClientBudget) {
      this.showClientBudget = false;
      this.showChecklist = true;
      this.showNextButton = true;
    }
  }
  checkGSTValidation() {
    console.log('gstnumber', this.formObj.value.gstNumber, this.formObj.value.pan);
    var twoChar = this.formObj.value.gstNumber.substring(0, 2);
    var newTwoChar = /^[0-9]{2}$/.test(twoChar);
    console.log('two char', newTwoChar);

    var lastThreeChar = this.formObj.value.gstNumber.substring(12, 16)
    var newlastThreeChar = /^[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(lastThreeChar);
    console.log('newlastThreeChar value', newlastThreeChar);

    var newGSTNumber = this.formObj.value.gstNumber.substring(2, 12);
    console.log('substring gstnumber', newGSTNumber);
    console.log('gst length', this.formObj.value.gstNumber.length);
    if (this.formObj.value.gstNumber.length == 15 && newGSTNumber == this.formObj.value.pan && newTwoChar && newlastThreeChar) {

    } else {
      this.commonMessageService.swalAlertWithoutIcon('', 'Please enter valid GST number');
      this.formObj.patchValue({
        gstNumber: ''
      })
    }
  }
  // Client
  onSaveClick() {
    console.log('on save', this.formObj.controls);
    if (this.formObj.valid) {
      if (this.formObj.value.isSign) {
        if (this.validateClientBudgetRequriedFields()) {
          console.log(this.formObj.value);
          if (this.validateClientBudget()) {
            console.log("Success")
            this.getValueFromModal()
            this.masterDataService
              .saveClient(this.getValueFromModal())
              .subscribe((resp) => {
                console.log('client created response', resp);
                this.changeModalFormObjList(resp);
                this.commonMessageService.swalAlertWithIcon('', 'Saved Successfully!', 'success');
                var status = 'success';
                this.closeModal(this.formStatus, 'success');
                this.router.navigate(['/dashboard/manage-client']);
              });
          } else {
            this.commonMessageService.swalAlertWithoutIcon('', 'Please create budget for all assignments...!');
          }
        }
      } else {
        this.commonMessageService.swalAlertWithoutIcon('', 'Please Sign Client Acceptance Checklist ...!');
      }
    } else {
      this.commonMessageService.swalAlertWithoutIcon('', 'Invalid form data...!');
    }
  }
  saveButtonEnabled = false;

  validateClientBudget() {
    var finalclientBudgetValid = true;
    var clientBudgetValid = false;
    var budget = [];
    console.log('budget value', budget);
    console.log("budgetDetails", this.formObj.controls.budgetDetails)
    for (let i = 0; i < this.formObj.controls.budgetDetails.length; i++) {
      var budgetObj = {
        assignedPartner: this.formObj.controls.budgetDetails.value[i].partner,
        assignment: this.formObj.controls.budgetDetails.value[i].assignment,
        assignmentFees: this.formObj.controls.budgetDetails.value[i]
          .assignmentFees,
        branch: this.formObj.value.branch,
        client: { id: this.formObj.value.id },
        financialYear: this.formObj.controls.budgetDetails.value[i].financialYear,
        id: 0,
        budgetDetails: [],
      };
      for (let j = 0; j < budget.length; j++) {
        var foundStatus = false
        if (budget[j].assignedPartner.id == budgetObj.assignedPartner.id &&
          budget[j].assignment.id == budgetObj.assignment.id &&
          budget[j].financialYear.id == budgetObj.financialYear.id) {
          foundStatus = true
        }
      }
      if (!foundStatus) {
        budget.push(budgetObj);
      }
    }
    for (let l = 0; l < this.partnerFinancialYearList.length; l++) {
      for (let m = 0; m < this.partnerFinancialYearList[l].assignments.length; m++) {
        for (let n = 0; n < this.partnerFinancialYearList[l].financailYear.length; n++) {
          var statusFound = false
          for (let j = 0; j < budget.length; j++) {
            if (budget[j].assignedPartner.id == this.partnerFinancialYearList[l].partner.id &&
              budget[j].assignment.id == this.partnerFinancialYearList[l].assignments[m].id &&
              budget[j].financialYear.id == this.partnerFinancialYearList[l].financailYear[n].id) {
              statusFound = true
            }
          }
          if (!statusFound) {
            finalclientBudgetValid = false
          }
        }
      }
    }

    console.log('clientBudgetValid', finalclientBudgetValid);

    // for(let i=0;i<budget.length;i++){
    //   var statusFound=false
    //   for(let j=0;j < this.budgetPartnersList.length;j++){
    //     console.log("budget[i].assignedPartner.id",budget[i].assignedPartner.id)
    //     console.log("this.budgetPartnersList[j].partner",this.budgetPartnersList[j].partner)
    //     if(budget[i].assignedPartner.id == this.budgetPartnersList[j].partner){
    //       for(let k=0;k<this.budgetPartnersList[j].assignments.length;k++){
    //         console.log("budget[i].assignment.id",budget[i].assignment.id)
    //         console.log("this.budgetPartnersList[j].assignments[k].id",this.budgetPartnersList[j].assignments[k].id)
    //         if(budget[i].assignment.id == this.budgetPartnersList[j].assignments[k].id){
    //           statusFound = true
    //         }
    //       }
    //     }
    //   }
    //   if(!statusFound){
    //     console.log("budget[i]",budget[i])
    //     finalclientBudgetValid = false
    //   }
    // }



    // for(let i=0;i < this.budgetPartnersList.length;i++){
    //   var statusFound=false
    //   for(let j=0;j<budget.length;j++){
    //     if(this.budgetPartnersList[i].partner == budget[j].assignedPartner.id){
    //       for(let k=0;k<this.budgetPartnersList[i].assignments.length;k++){
    //         if( budget[j].assignment.id == this.budgetPartnersList[i].assignments[k].id){
    //           statusFound = true
    //         }
    //       }
    //     }
    //   }
    //   if(!statusFound){
    //     finalclientBudgetValid = false
    //   }
    // }

    // for(let i=0;i < this.budgetPartnersList.length;i++){
    //   budgetValidationLength = budgetValidationLength + this.budgetPartnersList[i].assignments.length
    // }
    // console.log("budgetValidationLength",budgetValidationLength)

    // if(budget.length == budgetValidationLength){
    //   finalclientBudgetValid = true
    // }


    // var notValidate = 0;

    // for (let i = 0; i < this.formObj.value.partners.length; i++) {
    //   console.log(this.formObj.value.partners[i]);
    //   var checkIfAllAsingExist = [];
    //   var partnerExists = 0;
    //   for (let j = 0; j < this.formObj.controls.budgetDetails.length; j++) {
    //     if (
    //       this.formObj.value.partners[i].id ==
    //       this.formObj.controls.budgetDetails.value[j].partner.id
    //     ) {
    //       var asignName = '';
    //       console.log(
    //         'assignmentList',
    //         this.formObj.controls.budgetDetails.value[j].assignment.id
    //       );
    //       var exists = 0;
    //       for (
    //         let k = 0;
    //         k < this.formObj.value.partners[i].assignments.length;
    //         k++
    //       ) {
    //         console.log(
    //           'assignmentInList',
    //           this.formObj.value.partners[i].assignments[k].id
    //         );
    //         if (
    //           this.formObj.value.partners[i].assignments[k].id ==
    //           this.formObj.controls.budgetDetails.value[j].assignment.id
    //         ) {
    //           clientBudgetValid = true;
    //           exists = 1;
    //           asignName = this.formObj.value.partners[i].assignments[k].name;
    //         } else {
    //           if (exists == 0) {
    //             clientBudgetValid = false;
    //           }
    //         }
    //         console.log(
    //           this.formObj.value.partners[i].assignments[k].id +
    //           ' ' +
    //           clientBudgetValid
    //         );
    //       }

    //       var asignExistAarry = {
    //         valid: clientBudgetValid,
    //         name: asignName,
    //       };
    //       if (checkIfAllAsingExist.length > 0) {
    //         var exists1 = 0;
    //         for (let i = 0; i < checkIfAllAsingExist.length; i++) {
    //           if (checkIfAllAsingExist[i].name == asignExistAarry.name) {
    //             exists1 = 1;
    //           } else {
    //             if (exists1 == 0) {
    //               exists1 = 0;
    //             }
    //           }
    //         }
    //         if (exists1 == 0) {
    //           checkIfAllAsingExist.push(asignExistAarry);
    //         }
    //       } else {
    //         checkIfAllAsingExist.push(asignExistAarry);
    //       }
    //       partnerExists = 1;
    //       if (notValidate == 0) {
    //         finalclientBudgetValid = true;
    //       }
    //     } else {
    //       if (partnerExists == 0) {
    //         finalclientBudgetValid = false;
    //       }
    //     }
    //     console.log('assignmentwiase', checkIfAllAsingExist);
    //   }
    //   console.log(
    //     checkIfAllAsingExist.length +
    //     ' ' +
    //     this.formObj.value.partners[i].assignments.length
    //   );
    //   if (
    //     checkIfAllAsingExist.length ==
    //     this.formObj.value.partners[i].assignments.length
    //   ) {
    //     for (let i = 0; i < checkIfAllAsingExist.length; i++) {
    //       if (checkIfAllAsingExist[i].valid == false) {
    //         finalclientBudgetValid = false;
    //         notValidate = 1;
    //       }
    //     }
    //   } else {
    //     finalclientBudgetValid = false;
    //     notValidate = 1;
    //   }
    // }
    // console.log(finalclientBudgetValid);
    // console.log('clientBudgetValid', finalclientBudgetValid);
    return finalclientBudgetValid;
  }

  validateClientBudgetRequriedFields() {
    var clientBudgetValid = false;
    console.log(this.formObj.value);
    if (
      this.formObj.value.assignedPartner != null &&
      this.formObj.value.financialYear != null &&
      this.formObj.value.assignment != null &&
      this.formObj.value.role != null &&
      this.formObj.value.employee != null &&
      this.formObj.value.assignmentFees != null
    ) {
      clientBudgetValid = true;
      this.saveButtonEnabled = true;
    } else {
      clientBudgetValid = false;
      this.commonMessageService.swalAlertWithoutIcon('', 'Please enter values in all below fields...!');
    }
    return clientBudgetValid;
  }

  onDeleteClick(item) {
    console.log(item);
    Swal.fire({
      text: 'Are you sure you want to remove?',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      confirmButtonColor: '#800000'
    }).then((result) => {
      if (result.isConfirmed) {
        this.formStatus = 'delete';
        this.masterDataService.deleteClient(item.id).subscribe((resp) => {
          console.log(resp);
          this.changeModalFormObjList(item);
          this.commonMessageService.swalAlertWithIcon('', 'Deleted Successfully!', 'success');
        });
      }
    })
  }

  // OTHER FUNCTION
  findIndexForPartner(partner) {
    return this.partnerList.findIndex((item) => item.id == partner.id);
  }

  // GET AND SET VALUE FROM MODAL
  getValueFromModal() {
    let data: any;
    let client: any;
    data = {};
    client = {
      id: this.formObj.value.id,
      name: this.formObj.value.name,
      email: this.formObj.value.email,
      pan: this.formObj.value.pan,
      address: this.formObj.value.address,
      state: this.formObj.value.state,
      city: this.formObj.value.city,
      postCode: this.formObj.value.postCode,
      alias: '',
      principalPlaceOfBusiness: '',
      chargeableToClient: this.formObj.value.chargeableToClient,
      cinNumber: this.formObj.value.cinNumber,
      gstNumber: this.formObj.value.gstNumber,
      ediaryStatus: this.formObj.value.ediaryStatus,
      legalStatus: this.formObj.value.legalStatus,
      llpinNumber: this.formObj.value.llpinNumber,
      branch: this.formObj.value.branch,
      sector: this.formObj.value.sector,
      clientLocations: this.formObj.value.clientLocations,
      isSign: this.formObj.value.isSign,
      signDate: this.formObj.value.signDate,
    };

    /* budget= {
      assignedPartner : this.formObj.controls.budgetDetails.value.partner,
      assignment : this.formObj.controls.budgetDetails.value.assignment,
      assignmentFees : this.formObj.value.,
    } */

    client.partners = [];
    client.clientCheckList = [];
    client.clientEmails = [];

    // if (this.formObj.value.clientEmails && this.formObj.value.clientEmails.length==3) {

    //   for(var i=0;i<this.formObj.value.clientEmails.length;i++)
    //   {
    //     if(this.formObj.value.clientEmails[i].email!='' && this.formObj.value.clientEmails[i].email!=null)
    //     {

    //           client.clientEmails.push({
    //             id: this.formObj.value.clientEmails[i].id,
    //             email: this.formObj.value.clientEmails[i].email
    //           });


    //     }
    //   }



    // } 

    if (this.formObj.value.clientEmails?.length === 3) {
      client.clientEmails = this.formObj.value.clientEmails
        .filter(emailObj => emailObj.email && emailObj.email.trim() !== "") // Ensure non-empty, non-whitespace emails
        .map(emailObj => ({
          id: emailObj.id,
          email: emailObj.email.trim() // Optionally, trim the email before mapping
        }));
    }


    console.log("Parntner List", this.formObj.value.partners)

    for (let i = 0; i < this.formObj.value.partners.length; i++) {
      var fromDate = new Date(this.formObj.value.partners[i].fromDate.year + '-' + this.formObj.value.partners[i].fromDate.month + '-' + this.formObj.value.partners[i].fromDate.day);
      var toDate = new Date(this.formObj.value.partners[i].toDate.year + '-' + this.formObj.value.partners[i].toDate.month + '-' + this.formObj.value.partners[i].toDate.day);
      for (let j = 0; j < this.formObj.value.partners[i].assignments.length; j++) {
        const part = {
          assignment: this.formObj.value.partners[i].assignments[j],
          id: this.formObj.value.partners[i].id,
          fromDate: moment(fromDate).format('YYYY-MM-DD'),
          toDate: moment(toDate).format('YYYY-MM-DD'),
        };
        client.partners.push(part);
      }
    }
    console.log("client.partners", client.partners)

    // this.formObj.value.partners.forEach((partner, partnerKey) => {
    //   // console.log(partner);
    //   var fromDate = new Date(
    //     partner.fromDate.year +
    //     '-' +
    //     partner.fromDate.month +
    //     '-' +
    //     partner.fromDate.day
    //   );
    //   var toDate = new Date(
    //     partner.toDate.year +
    //     '-' +
    //     partner.toDate.month +
    //     '-' +
    //     partner.toDate.day
    //   );
    //   partner.assignments.forEach((assignment, assignmentkey) => {
    //     const part = {
    //       assignment: assignment,
    //       id: partner.id,
    //       fromDate: moment(fromDate).format('YYYY-MM-DD'),
    //       toDate: moment(toDate).format('YYYY-MM-DD'),
    //     };
    //     client.partners.push(part);
    //   });
    // });

    this.formObj.value.clientCheckList.forEach((checklist, cKey) => {
      var checklistObj = {
        checklistDetail: { id: checklist.questionId },
        isRequired: checklist.isRequired,
        remark: checklist.remark,
        id: '',
      };
      if (this.formStatus == 'edit') {
        checklistObj.id = checklist.id;
      }
      client.clientCheckList.push(checklistObj);
    });

    var budget = [];
    console.log(budget.length);
    console.log("budgetDetails", this.formObj.controls.budgetDetails)
    for (let i = 0; i < this.formObj.controls.budgetDetails.length; i++) {
      var budgetObj = {
        assignedPartner: this.formObj.controls.budgetDetails.value[i].partner,
        assignment: this.formObj.controls.budgetDetails.value[i].assignment,
        assignmentFees: this.formObj.controls.budgetDetails.value[i]
          .assignmentFees,
        branch: this.formObj.value.branch,
        client: { id: this.formObj.value.id },
        financialYear: this.formObj.controls.budgetDetails.value[i].financialYear,
        id: 0,
        budgetDetails: [],
      };
      for (let j = 0; j < budget.length; j++) {
        var foundStatus = false
        if (budget[j].assignedPartner.id == budgetObj.assignedPartner.id &&
          budget[j].assignment.id == budgetObj.assignment.id &&
          budget[j].financialYear.id == budgetObj.financialYear.id) {
          foundStatus = true
        }
      }
      if (!foundStatus) {
        budget.push(budgetObj);
      }

    }

    console.log('budget', budget);

    var budgetDetails = [];
    for (let i = 0; i < budget.length; i++) {
      for (let j = 0; j < this.formObj.controls.budgetDetails.length; j++) {
        if (budget[i].assignedPartner.id == this.formObj.controls.budgetDetails.value[j].partner.id &&
          budget[i].assignment.id == this.formObj.controls.budgetDetails.value[j].assignment.id &&
          budget[i].financialYear.id == this.formObj.controls.budgetDetails.value[j].financialYear.id) {
          var budgetDetailsObj = {
            budgetedDays: this.formObj.controls.budgetDetails.value[j].budgetedDays,
            count: this.formObj.controls.budgetDetails.value[j].count,
            id: this.formObj.controls.budgetDetails.value[j].id,
            role: this.formObj.controls.budgetDetails.value[j].role,
            serviceVertical: this.formObj.controls.budgetDetails.value[j].serviceVertical,
            standardRate: this.formObj.controls.budgetDetails.value[j]
              .standardRate,
            user: this.formObj.controls.budgetDetails.value[j].user,
          };
          budget[i].budgetDetails.push(budgetDetailsObj);
        }
      }
    }

    console.log('budget', budget);
    data['client'] = client;
    data['budget'] = budget;

    console.log('client', client);
    console.log('budget', budget);

    console.log('data', data);

    var jsonData = JSON.stringify(data);
    console.log(jsonData);
    return jsonData;
  }

  // Edit Client
  getPartnerArrayFromEditObject() {
    var selectedPartnerList = [];
    var newObj = { id: 0, assignments: [], fromDate: '', toDate: '' };
    console.log('editObjectTemp', this.editObjectTemp);
    console.log(' this.formObj.controls.partners', this.formObj.controls);
    if (this.formStatus == 'edit') {
      this.editGlobalResponse.client.partners.forEach((element, key) => {
        var index = selectedPartnerList.findIndex(
          (item) => item.id === element.id
        );
        if (index >= 0) {
          var existingObj = selectedPartnerList[index];
          var assignIndex = this.assignmentList.findIndex(
            (item) => item.id === element.assignment.id
          );
          existingObj.assignments.push({ ...this.assignmentList[assignIndex] });
        } else {
          newObj = { id: 0, assignments: [], fromDate: '', toDate: '' };
          newObj = {
            id: element.id,
            assignments: [],
            fromDate: element.fromDate,
            toDate: element.toDate,
          };
          var assignIndex = this.assignmentList.findIndex(
            (item) => item.id === element.assignment.id
          );
          newObj.assignments.push({ ...this.assignmentList[assignIndex] });
          selectedPartnerList.push(newObj);
        }
      });
    } else {
      this.formObj.controls.partners.value.forEach((element, key) => {
        var index = selectedPartnerList.findIndex(
          (item) => item.id === element.id
        );
        if (index >= 0) {
          var existingObj = selectedPartnerList[index];
          var assignIndex = this.assignmentList.findIndex(
            (item) => item.id === element.assignment.id
          );
          existingObj.assignments.push({ ...this.assignmentList[assignIndex] });
        } else {
          newObj = { id: 0, assignments: [], fromDate: '', toDate: '' };
          newObj = {
            id: element.id,
            assignments: [],
            fromDate: element.fromDate,
            toDate: element.toDate,
          };
          var assignIndex = this.assignmentList.findIndex(
            (item) => item.id === element.assignment.id
          );
          newObj.assignments.push({ ...this.assignmentList[assignIndex] });
          selectedPartnerList.push(newObj);
        }
      });
    }

    return selectedPartnerList;
  }

  checkPartnerArrayEqualsOrNot() {
    var isNotEqual = false;
    //if (this.editObjectTemp) {
    console.log('editObjectTemp', this.editObjectTemp);
    var oldArray = this.getPartnerArrayFromEditObject();
    var newArray = [...this.formObj.value.partners];
    console.log('oldArray', oldArray);
    console.log('newArray', newArray);
    if (oldArray.length == newArray.length) {
      console.log('1....');
      console.log(oldArray);
      console.log(newArray);
      oldArray.forEach((oldElement, oldKey) => {
        console.log(oldElement);
        console.log(newArray[oldKey]);
        if (newArray[oldKey]) {
          console.log(newArray[oldKey].fromDate);
          var fromDate1 = new Date(
            newArray[oldKey].fromDate.year +
            '-' +
            newArray[oldKey].fromDate.month +
            '-' +
            newArray[oldKey].fromDate.day
          );
          console.log(fromDate1);
          var toDate1 = new Date(
            newArray[oldKey].toDate.year +
            '-' +
            newArray[oldKey].toDate.month +
            '-' +
            newArray[oldKey].toDate.day
          );
          console.log(toDate1);
          var fromDate = moment(fromDate1).format('YYYY-MM-DD');
          var toDate = moment(toDate1).format('YYYY-MM-DD');
          console.log(oldElement.id == newArray[oldKey].id);
          console.log(oldElement.fromDate == fromDate);
          console.log(oldElement.toDate == toDate);
          if (
            oldElement.id == newArray[oldKey].id &&
            oldElement.fromDate == fromDate &&
            oldElement.toDate == toDate
          ) {
            if (newArray[oldKey].assignments) {
              if (
                oldElement.assignments.length ==
                newArray[oldKey].assignments.length
              ) {
                var uncommonElementArray = [];
                oldElement.assignments.forEach((assignment, akey) => {
                  if (
                    assignment.id == newArray[oldKey].assignments[akey].id
                  ) {
                  } else {
                    uncommonElementArray.push[assignment];
                  }
                });
                if (uncommonElementArray.length > 0) {
                  console.log('2....');
                  isNotEqual = true;
                }
              } else {
                console.log('3....');
                isNotEqual = true;
              }
            }
          } else {
            console.log('4....');
            isNotEqual = true;
          }
        }
      });
    } else {
      console.log('5....');
      isNotEqual = true;
    }
    // }
    return isNotEqual;
  }

  editObjectTemp: any;
  editPage = 0;
  selectedForm;
  onEditClick(formObj) {
    console.log(formObj);
    console.log('check edit form')

    //this.onLegalStatusChange();
    this.selectedForm = formObj;
    this.viewModalFormObj(formObj);
  }
  editGlobalResponse;
  viewModalFormObj(formObj) {
    console.log('id', formObj.id);

    this.masterDataService.viewClient(formObj.id).subscribe((resp) => {
      console.log('edit resp', resp);
      this.editGlobalResponse = resp;
      this.editObjectTemp = { ...resp };
      this.setValueToModalForm(resp);
      this.openModal('edit');


    });

  }

  addClientBudgetIntoExistingJson(editGlobalResponse) {
    var client = editGlobalResponse.client;

    var data = {};
    data['client'] = client;
    data['budget'] = editGlobalResponse.budget;
    console.log('edit Data', data);
    console.log('budgetDetails', this.formObj.controls.budgetDetails);

    for (let i = 0; i < this.formObj.controls.budgetDetails.length; i++) {
      console.log('1...........................1')
      var budgetObj = {
        assignedPartner: this.formObj.controls.budgetDetails.value[i].partner,
        assignment: this.formObj.controls.budgetDetails.value[i].assignment,
        assignmentFees: this.formObj.controls.budgetDetails.value[i]
          .assignmentFees,
        branch: this.formObj.value.branch,
        client: { id: this.formObj.value.id },
        financialYear: this.formObj.controls.budgetDetails.value[i].financialYear,
        id: 0,
        budgetDetails: [],
      };
      var foundStatus = false;
      for (let j = 0; j < editGlobalResponse.budget.length; j++) {
        // if(editGlobalResponse.budget[j].assignment!=null){
        if (editGlobalResponse.budget[j].assignedPartner.id == this.formObj.controls.budgetDetails.value[i].partner.id &&
          editGlobalResponse.budget[j].assignment.id == this.formObj.controls.budgetDetails.value[i].assignment.id &&
          editGlobalResponse.budget[j].financialYear.id == this.formObj.controls.budgetDetails.value[i].financialYear.id) {
          foundStatus = true;
        }
        // }
      }
      if (foundStatus == false) {
        console.log('in push');
        editGlobalResponse.budget.push(budgetObj);
      }
    }

    for (let i = 0; i < this.formObj.controls.budgetDetails.length; i++) {
      console.log('2...........................1')

      var budgetDetailsObj = {
        budgetedDays: this.formObj.controls.budgetDetails.value[i].budgetedDays,
        count: this.formObj.controls.budgetDetails.value[i].count,
        id: this.formObj.controls.budgetDetails.value[i].id,
        role: this.formObj.controls.budgetDetails.value[i].role,
        serviceVertical: this.formObj.controls.budgetDetails.value[i].serviceVertical,
        standardRate: this.formObj.controls.budgetDetails.value[i].standardRate,
        user: this.formObj.controls.budgetDetails.value[i].user,
      };
      for (let j = 0; j < editGlobalResponse.budget.length; j++) {
        if (editGlobalResponse.budget[j].assignment != null) {
          if (editGlobalResponse.budget[j].assignedPartner.id == this.formObj.controls.budgetDetails.value[i].partner.id &&
            editGlobalResponse.budget[j].assignment.id == this.formObj.controls.budgetDetails.value[i].assignment.id &&
            editGlobalResponse.budget[j].financialYear.id == this.formObj.controls.budgetDetails.value[i].financialYear.id) {
            var foundStatus1 = false;
            for (let k = 0; k < editGlobalResponse.budget[j].budgetDetails.length; k++) {
              console.log('budgetDetails', editGlobalResponse.budget[j].budgetDetails[k].role, ' ', this.formObj.controls.budgetDetails.value[i].role);
              if (editGlobalResponse.budget[j].budgetDetails[k].role.id == budgetDetailsObj.role.id &&
                editGlobalResponse.budget[j].budgetDetails[k].user.id == budgetDetailsObj.user.id) {
                foundStatus1 = true;
              }
            }
          }
        }
        if (foundStatus1 == false) {
          console.log('in budget detail push');
          editGlobalResponse.budget[j].budgetDetails.push(budgetDetailsObj);
        }
      }
    }

    console.log('addClientBudgetIntoExistingJson', editGlobalResponse);

    return editGlobalResponse;
  }

  validateAllAssignmentBudget(editGlobalResponse) {
    // var finalclientBudgetValid = false;
    var clientBudgetValid = false;
    var notValidate = 0;

    // var budgetValidationLength = 0
    // for(let i=0;i < this.budgetPartnersList.length;i++){
    //   budgetValidationLength = budgetValidationLength + this.budgetPartnersList[i].assignments.length
    // }
    // console.log("budgetValidationLength",budgetValidationLength)

    // if(editGlobalResponse.budget.length == budgetValidationLength){
    //   finalclientBudgetValid = true
    //   for(let i=0;i<editGlobalResponse.budget.length;i++){
    //     if(editGlobalResponse.budget[i].budgetDetails.length==0){
    //       finalclientBudgetValid = false
    //     }
    //   }
    // }

    // var partnerList = [];
    // console.log("this.formObj.value.partners",this.formObj.value.partners)
    // for(let i=0;i< this.formObj.value.partners.length;i++){
    //   var fromDate = new Date(this.formObj.value.partners[i].fromDate.year +'-' + this.formObj.value.partners[i].fromDate.month + '-' + this.formObj.value.partners[i].fromDate.day);
    //   var toDate = new Date(this.formObj.value.partners[i].toDate.year +'-' + this.formObj.value.partners[i].toDate.month + '-' + this.formObj.value.partners[i].toDate.day);
    //   for(let j=0;j<this.formObj.value.partners[i].assignments.length;j++){
    //     const part = {
    //       assignment: this.formObj.value.partners[i].assignments[j],
    //       id: this.formObj.value.partners[i].id,
    //       fromDate: moment(fromDate).format('YYYY-MM-DD'),
    //       toDate: moment(toDate).format('YYYY-MM-DD'),
    //     };
    //     partnerList.push(part);
    //   }
    // }
    // console.log("client.partners",partnerList)

    var previousAndCurrentYearPartnerList = this.partnerFinancialYearList;

    for (let i = 0; i < previousAndCurrentYearPartnerList.length; i++) {
      for (let k = 0; k < previousAndCurrentYearPartnerList[i].financailYear.length; k++) {
        var statusFound = false;
        for (let j = 0; j < this.budgetFinancialYearList.length; j++) {
          console.log('financialYear[k]', previousAndCurrentYearPartnerList[i]);
          if (previousAndCurrentYearPartnerList[i].financailYear[k].id == this.budgetFinancialYearList[j].id) {
            statusFound = true;
          }
        }
        if (!statusFound) {
          previousAndCurrentYearPartnerList.splice(i, 1);
        }
      }
    }

    console.log('previousAndCurrentYearPartnerList', previousAndCurrentYearPartnerList);
    console.log("budgetPartnerList", this.budgetPartnersList)
    console.log("editGlobalResponse", editGlobalResponse)
    var finalclientBudgetValid = true
    for (let j = 0; j < previousAndCurrentYearPartnerList.length; j++) {
      for (let k = 0; k < previousAndCurrentYearPartnerList[j].assignments.length; k++) {
        for (let l = 0; l < previousAndCurrentYearPartnerList[j].financailYear.length; l++) {
          var assignmentBudgetFound = false
          for (let i = 0; i < editGlobalResponse.budget.length; i++) {
            // if(editGlobalResponse.budget[i].assignment!=null){
            if (previousAndCurrentYearPartnerList[j].assignments[k].id == editGlobalResponse.budget[i].assignment.id
              && previousAndCurrentYearPartnerList[j].partner.id == editGlobalResponse.budget[i].assignedPartner.id
              && previousAndCurrentYearPartnerList[j].financailYear[l].id == editGlobalResponse.budget[i].financialYear.id) {
              assignmentBudgetFound = true
            }
            // }
          }
          if (!assignmentBudgetFound) {
            console.log("Assignment not found")
            finalclientBudgetValid = false
          }
          previousAndCurrentYearPartnerList[j].assignments[k]['budgetExists'] = assignmentBudgetFound
        }
      }
    }

    console.log("AftterBudgetExistsbudgetPartnerList", previousAndCurrentYearPartnerList)
    //finalclientBudgetValid = true
    // for(let j=0;j<this.budgetPartnersList.length;j++){
    //   for(let k=0;k<this.budgetPartnersList[j].assignments.length;k++){
    //     if(this.budgetPartnersList[j].assignments[k].budgetExists == false){
    //       finalclientBudgetValid = false
    //     }
    //   }
    // }
    console.log("editGlobalResponse", editGlobalResponse)
    console.log("finalclientBudgetValid", finalclientBudgetValid)
    // for (let i = 0; i < this.formObj.value.partners.length; i++) {
    //   console.log(this.formObj.value.partners[i]);
    //   var checkIfAllAsingExist = [];
    //   var partnerExists = 0;
    //   for (let j = 0; j < editGlobalResponse.budget.length; j++) {
    //     if (
    //       this.formObj.value.partners[i].id ==
    //       editGlobalResponse.budget[j].assignedPartner.id
    //     ) {
    //       var asignName = '';
    //       console.log(
    //         'assignmentList',
    //         editGlobalResponse.budget[j].assignment.id
    //       );
    //       var exists = 0;
    //       for (
    //         let k = 0;
    //         k < this.formObj.value.partners[i].assignments.length;
    //         k++
    //       ) {
    //         console.log(
    //           'assignmentInList',
    //           this.formObj.value.partners[i].assignments[k].id
    //         );
    //         if (
    //           this.formObj.value.partners[i].assignments[k].id ==
    //           editGlobalResponse.budget[j].assignment.id
    //         ) {
    //           clientBudgetValid = true;
    //           exists = 1;
    //           asignName = this.formObj.value.partners[i].assignments[k].name;
    //         } else {
    //           if (exists == 0) {
    //             clientBudgetValid = false;
    //           }
    //         }
    //         console.log(
    //           this.formObj.value.partners[i].assignments[k].id +
    //           ' ' +
    //           clientBudgetValid
    //         );
    //       }

    //       var asignExistAarry = {
    //         valid: clientBudgetValid,
    //         name: asignName,
    //       };
    //       if (checkIfAllAsingExist.length > 0) {
    //         var exists1 = 0;
    //         for (let i = 0; i < checkIfAllAsingExist.length; i++) {
    //           if (checkIfAllAsingExist[i].name == asignExistAarry.name) {
    //             exists1 = 1;
    //           } else {
    //             if (exists1 == 0) {
    //               exists1 = 0;
    //             }
    //           }
    //         }
    //         if (exists1 == 0) {
    //           checkIfAllAsingExist.push(asignExistAarry);
    //         }
    //       } else {
    //         checkIfAllAsingExist.push(asignExistAarry);
    //       }
    //       partnerExists = 1;
    //       if (notValidate == 0) {
    //         finalclientBudgetValid = true;
    //       }
    //     } else {
    //       if (partnerExists == 0) {
    //         finalclientBudgetValid = false;
    //       }
    //     }
    //     console.log('assignmentwiase', checkIfAllAsingExist);
    //   }
    //   console.log(
    //     checkIfAllAsingExist.length +
    //     ' ' +
    //     this.formObj.value.partners[i].assignments.length
    //   );
    //   if (
    //     checkIfAllAsingExist.length ==
    //     this.formObj.value.partners[i].assignments.length
    //   ) {
    //     for (let i = 0; i < checkIfAllAsingExist.length; i++) {
    //       if (checkIfAllAsingExist[i].valid == false) {
    //         finalclientBudgetValid = false;
    //         notValidate = 1;
    //       }
    //     }
    //   } else {
    //     finalclientBudgetValid = false;
    //     notValidate = 1;
    //   }
    // }
    // console.log('validateAllAssignmentBudget', finalclientBudgetValid);

    return finalclientBudgetValid;
  }

  getValueFromModalEdit(editGlobalResponse) {
    console.log('editGlobalResponseJSONMODALEDit', editGlobalResponse);
    let data: any;
    let client: any;
    let budget: any;
    data = {};
    client = {
      id: this.formObj.value.id,
      name: this.formObj.value.name,
      email: this.formObj.value.email,
      pan: this.formObj.value.pan,
      address: this.formObj.value.address,
      state: this.formObj.value.state,
      city: this.formObj.value.city,
      postCode: this.formObj.value.postCode,
      alias: '',
      principalPlaceOfBusiness: '',
      chargeableToClient: this.formObj.value.chargeableToClient,
      cinNumber: this.formObj.value.cinNumber,
      gstNumber: this.formObj.value.gstNumber,
      ediaryStatus: this.formObj.value.ediaryStatus,
      legalStatus: this.formObj.value.legalStatus,
      llpinNumber: this.formObj.value.llpinNumber,
      branch: this.formObj.value.branch,
      sector: this.formObj.value.sector,
      clientLocations: this.formObj.value.clientLocations,
      isSign: this.formObj.value.isSign,
      signDate: this.formObj.value.signDate,
    };

    /* budget= {
      assignedPartner : this.formObj.controls.budgetDetails.value.partner,
      assignment : this.formObj.controls.budgetDetails.value.assignment,
      assignmentFees : this.formObj.value.,
    } */

    client.partners = [];
    client.clientCheckList = [];
    client.clientEmails = [];


    if (this.formObj.value.clientEmails?.length === 3) {
      client.clientEmails = this.formObj.value.clientEmails
        .filter(emailObj => emailObj.email && emailObj.email.trim() !== "") // Ensure non-empty, non-whitespace emails
        .map(emailObj => ({
          id: emailObj.id,
          email: emailObj.email.trim() // Optionally, trim the email before mapping
        }));
    }

    console.log("this.formObj.value.partners", this.formObj.value.partners)
    for (let i = 0; i < this.formObj.value.partners.length; i++) {
      var fromDate = new Date(this.formObj.value.partners[i].fromDate.year + '-' + this.formObj.value.partners[i].fromDate.month + '-' + this.formObj.value.partners[i].fromDate.day);
      var toDate = new Date(this.formObj.value.partners[i].toDate.year + '-' + this.formObj.value.partners[i].toDate.month + '-' + this.formObj.value.partners[i].toDate.day);
      for (let j = 0; j < this.formObj.value.partners[i].assignments.length; j++) {
        const part = {
          assignment: this.formObj.value.partners[i].assignments[j],
          id: this.formObj.value.partners[i].id,
          fromDate: moment(fromDate).format('YYYY-MM-DD'),
          toDate: moment(toDate).format('YYYY-MM-DD'),
        };
        client.partners.push(part);
      }
    }
    console.log("client.partners", client.partners)

    this.formObj.value.clientCheckList.forEach((checklist, cKey) => {
      var checklistObj = {
        checklistDetail: { id: checklist.questionId },
        isRequired: checklist.isRequired,
        remark: checklist.remark,
        id: '',
      };
      if (this.formStatus == 'edit') {
        checklistObj.id = checklist.id;
      }
      client.clientCheckList.push(checklistObj);
    });

    budget = editGlobalResponse.budget;

    data['client'] = client;
    data['budget'] = budget;
    /* data.push(client);
    data.push(budget); */
    console.log('client', client);
    console.log('budget', budget);

    var jsonData = JSON.stringify(data);
    console.log(jsonData);
    return jsonData;
  }

  onUpdateClick() {
    console.log('on update click', this.editGlobalResponse);
    console.log(this.formObj);

    this.formSubmitted = true;
    this.logValidationErrors(this.formObj);
    console.log(this.formObj);
    if (this.formObj.valid) {
      if (this.formObj.value.isSign) {
        var isNotEqual = this.checkPartnerArrayEqualsOrNot();
        console.log('updateIsNotEqual', isNotEqual);
        var clientBudgetStory = false;
        if (this.showClientBudget) {
          // if(this.validateClientBudgetRequriedFields()){
          var editGlobalResponse = this.addClientBudgetIntoExistingJson(this.editGlobalResponse);
          //console.log("this.validateAllAssignmentBudget(editGlobalResponse)",this.validateAllAssignmentBudget(editGlobalResponse))
          //clientBudgetStory = false;
          if (this.validateAllAssignmentBudget(editGlobalResponse)) {
            clientBudgetStory = true;
          }
        } else {
          clientBudgetStory = true;
        }
        if (clientBudgetStory) {
          console.log('inside update method', clientBudgetStory);
          this.getValueFromModalEdit(this.editGlobalResponse);
          this.masterDataService
            .updateClient(this.getValueFromModalEdit(this.editGlobalResponse))
            .subscribe((resp) => {
              console.log(resp);
              this.changeModalFormObjList(resp);
              var status = 'success';
              this.closeModal(this.formStatus, 'success');
              this.commonMessageService.swalAlertWithIcon('', 'Updated Successfully!', 'success');
              if (isNotEqual) {
                this.router.navigate(['/dashboard/manage-client'], {
                  queryParams: { clientId: resp.id, branchId: resp.branch.id },
                });
              }
            });
        } else {
          this.commonMessageService.swalAlertWithoutIcon('', 'Please create budget for all assignments...!');
        }
      } else {
        this.commonMessageService.swalAlertWithoutIcon('', 'Please Sign Client Acceptance Checklist ...!');
      }
    } else {
      this.commonMessageService.swalAlertWithoutIcon('', 'Invalid form data...!');
    }
  }

  globalMaxDate = null

  setValueToModalForm(modalObj) {
    console.log(modalObj);
    console.log("modalObj.client", modalObj.client)
    const ediaryStatusIndex = this.ediaryStatusList.findIndex(
      (item) => item.id == modalObj.client.ediaryStatus.id
    );
    const legalStatusIndex = this.legalStatusList.findIndex(
      (item) => item.id == modalObj.client.legalStatus.id
    );

    var branchIndex = ''
    if (modalObj.client.branch == null) {
      branchIndex = null
    } else {
      branchIndex = this.branchList.findIndex(
        (item) => item.id == modalObj.client.branch.id
      );
    }

    var sectorIndex = ''
    if (modalObj.client.sector == null) {
      sectorIndex = null
    } else {
      sectorIndex = this.sectorList.findIndex(
        (item) => item.id == modalObj.client.sector.id
      );
    }
    var stateIndex = ''
    if (modalObj.client.state == null) {
      stateIndex = null
    } else {
      stateIndex = this.stateList.findIndex(
        (item) => item.id == modalObj.client.state.id
      );
    }


    this.formObj.patchValue({
      id: modalObj.client.id,
      name: modalObj.client.name,
      email: modalObj.client.email,
      pan: modalObj.client.pan,
      address: modalObj.client.address,
      state: this.stateList[stateIndex],
      city: modalObj.client.city,
      postCode: modalObj.client.postCode,
      alias: modalObj.client.alias,
      chargeableToClient: modalObj.client.chargeableToClient,
      cinNumber: modalObj.client.cinNumber,
      gstNumber: modalObj.client.gstNumber,
      principalPlaceOfBusiness: modalObj.client.principalPlaceOfBusiness,
      ediaryStatus: this.ediaryStatusList[ediaryStatusIndex],
      legalStatus: this.legalStatusList[legalStatusIndex],
      llpinNumber: modalObj.client.llpinNumber,
      branch: this.branchList[branchIndex],
      sector: this.sectorList[sectorIndex],
      isSign: [null, []],
      signDate: [new Date()],
    });
    this.formObj.controls['partners'].clear();
    this.formObj.controls['clientLocations'].clear();
    this.formObj.controls['clientEmails'].clear();

    // if (modalObj.client.clientEmails && modalObj.client.clientEmails.length==3) {
    //   this.multipleEmails=true;
    //   modalObj.client.clientEmails.forEach(email => {
    //     this.clientEmails.push(
    //       this.fb.group({
    //         id: [email.id],
    //         email: [email.email]
    //       })
    //     );
    //   });
    // } else {
    //   // Add default empty email objects if no data from the backend

    //   this.clientEmails.push(this.addEmailFormGroup());
    //   this.clientEmails.push(this.addEmailFormGroup());
    //   this.clientEmails.push(this.addEmailFormGroup());
    // }

    if (modalObj.client.clientEmails?.length) {
      this.multipleEmails = true;

      // Add existing emails from the response
      modalObj.client.clientEmails.forEach(email => {
        this.clientEmails.push(
          this.fb.group({
            id: [email.id],
            email: [email.email],
          })
        );
      });

      // Add additional empty email objects to make the total count 3
      const missingCount = 3 - modalObj.client.clientEmails.length;
      for (let i = 0; i < missingCount; i++) {
        this.clientEmails.push(this.addEmailFormGroup());
      }
    } else {
      // If no data from the backend, initialize with 3 empty email objects
      for (let i = 0; i < 3; i++) {
        this.clientEmails.push(this.addEmailFormGroup());
      }
    }


    console.log("this.financialYearList", this.financialYearList[0].endDate)
    this.globalMaxDate = null
    var maxDate = new Date(this.financialYearList[0].endDate);
    var maxDate1 = moment(maxDate, 'YYYY/MM/DD');
    this.globalMaxDate = {
      year: parseInt(maxDate1.format('YYYY')),
      month: parseInt(maxDate1.format('M')),
      day: parseInt(maxDate1.format('D')),
    };
    //var globalMaxDate = new Date(this.formObj.value.partners[i].fromDate.year +'-' + this.formObj.value.partners[i].fromDate.month + '-' + this.formObj.value.partners[i].fromDate.day);
    // this.formObj.controls['isSign'].setErrors({ required: null });
    // this.formObj.get('isSign').clearValidators();
    // this.formObj.controls['isSign'].updateValueAndValidity();
    if (modalObj.client.clientCheckList.length > 0) {
      this.formObj.controls['isSign'].setValue(true);
    }
    this.loadFinancialYear();
    this.initPartnerNlocationForEdit(modalObj);
    this.initClientBudgetScreen(modalObj);
    this.onLegalStatusChange();
    //this.budgetExistsCheckForAllAssignments();
  }
  // budgetExistsCheckForAllAssignments(){
  //   console.log("selectedPartnerList",this.selectedPartnerList)
  //   for(let i=0;i<this.selectedPartnerList.length;i++){
  //     for(let j=0;j<this.editGlobalResponse.budget.length;j++){
  //       if(this.selectedPartnerList[i].id == )
  //     }
  //   }
  // }
  initClientBudgetScreen(modalObj) {
    this.loadRoles();
  }


  selectedPartnerList = [];
  initPartnerNlocationForEdit(modalObj) {

    this.selectedPartnerList = [];
    console.log("modalObj.client.partners", modalObj.client.partners)



    for (let i = 0; i < modalObj.client.partners.length; i++) {
      var statusFound = false
      for (let j = 0; j < this.selectedPartnerList.length; j++) {
        if (this.selectedPartnerList[j].id == modalObj.client.partners[i].id &&
          this.selectedPartnerList[j].fromDate == modalObj.client.partners[i].fromDate &&
          this.selectedPartnerList[j].toDate == modalObj.client.partners[i].toDate) {
          statusFound = true
        }
      }




      if (!statusFound) {
        var assignments = []
        var partner = {
          id: modalObj.client.partners[i].id,
          fromDate: modalObj.client.partners[i].fromDate,
          toDate: modalObj.client.partners[i].toDate,
        }
        console.log("partner", partner)
        for (let k = 0; k < modalObj.client.partners.length; k++) {
          if (partner.id == modalObj.client.partners[k].id &&
            partner.fromDate == modalObj.client.partners[k].fromDate &&
            partner.toDate == modalObj.client.partners[k].toDate) {
            var assignIndex = this.assignmentList.findIndex((item) => item.id === modalObj.client.partners[k].assignment.id);
            console.log("assignment", this.assignmentList[assignIndex])
            assignments.push(this.assignmentList[assignIndex])
          }
        }
        partner['assignments'] = assignments

        this.selectedPartnerList.push(partner)
      }

    }


    // console.log("this.financialYearList",this.financialYearList)
    // for(let i=0;i<modalObj.client.partners.length;i++){
    //   var fy = null
    //   for(let j=0;j < this.financialYearList.length;j++){
    //     if(modalObj.client.partners[i].toDate <= this.financialYearList[j].endDate){
    //       console.log(this.financialYearList[j] , " ", modalObj.client.partners[i])
    //        fy = this.financialYearList[j]
    //        console.log("fy",fy)
    //     }
    //   }
    //   modalObj.client.partners[i]['financialYear'] = fy;
    //   console.log("modalObj.client.partner",modalObj.client.partners[i])
    // }
    // console.log("modalObj.client.partners",modalObj.client.partners)

    // for(let i=0;i<modalObj.client.partners.length;i++){
    //   var statusFound = false
    //   for(let j=0;j<this.selectedPartnerList.length;j++){
    //     if(this.selectedPartnerList[j].id == modalObj.client.partners[i].id &&
    //        this.selectedPartnerList[j].financialYear.id == modalObj.client.partners[i].financialYear.id){
    //         statusFound = true
    //     }
    //   }
    //   if(!statusFound){
    //       var assignments = []
    //       var partner={
    //         id : modalObj.client.partners[i].id,
    //         fromDate: modalObj.client.partners[i].fromDate,
    //         toDate:  modalObj.client.partners[i].toDate,
    //         financialYear : modalObj.client.partners[i].financialYear
    //       }
    //       console.log("partner",partner)
    //       for(let k=0;k<modalObj.client.partners.length;k++){
    //         if(partner.id == modalObj.client.partners[k].id &&
    //           partner.financialYear.id == modalObj.client.partners[k].financialYear.id){
    //             var assignIndex = this.assignmentList.findIndex((item) => item.id === modalObj.client.partners[k].assignment.id);
    //             console.log("assignment",this.assignmentList[assignIndex])
    //           assignments.push(this.assignmentList[assignIndex])
    //         }
    //       }
    //       partner['assignments'] = assignments

    //       this.selectedPartnerList.push(partner)
    //   }
    // }
    // var newObj = { id: 0, assignments: [], fromDate: '', toDate: '' };
    // modalObj.client.partners.forEach((element, key) => {
    //   var index = selectedPartnerList.findIndex(
    //     (item) => item.id === element.id
    //   );
    //   if (index >= 0) {
    //     var existingObj = selectedPartnerList[index];
    //     var assignIndex = this.assignmentList.findIndex(
    //       (item) => item.id === element.assignment.id
    //     );
    //     existingObj.assignments.push({ ...this.assignmentList[assignIndex] });
    //   } else {
    //     newObj = { id: 0, assignments: [], fromDate: '', toDate: '' };
    //     newObj = {
    //       id: element.id,
    //       assignments: [],
    //       fromDate: element.fromDate,
    //       toDate: element.toDate,
    //     };
    //     var assignIndex = this.assignmentList.findIndex(
    //       (item) => item.id === element.assignment.id
    //     );
    //     newObj.assignments.push({ ...this.assignmentList[assignIndex] });
    //     selectedPartnerList.push(newObj);
    //   }
    // });

    console.log('selectedPartnerList', this.selectedPartnerList);
    if (this.selectedPartnerList.length > 0) {
      this.selectedPartnerList.forEach((element, key) => {
        this.addPartnerFormGroupInEdit(element);
      });
    } else {
      let partnerFormGroup = this.fb.group({
        id: [''],
        assignments: ['', Validators.required],
        fromDate: ['', Validators.required],
        toDate: ['', Validators.required],
      });

      (<FormArray>this.formObj.get('partners')).push(partnerFormGroup);
    }


    modalObj.client.clientLocations.forEach((element, key) => {
      this.addLocationFormGroupInEdit(element);
    });

    var clientCheckListControl = this.formObj.get(
      'clientCheckList'
    ) as FormArray;
    modalObj.client.clientCheckList.forEach((element, key) => {
      var item1 = clientCheckListControl.at(key) as FormGroup;
      item1.patchValue({
        id: element.id,
        questionId: element.checklistDetail.id,
        questionNo: element.checklistDetail.questionNo,
        question: element.checklistDetail.question,
        isRequired: element.isRequired,
        remark: element.remark,
      });
    });
  }
  partner: FormGroup;
  addPartnerFormGroupInEdit(partner) {
    console.log(partner);
    var fromDate1 = new Date(partner.fromDate);
    var fromDate2 = moment(fromDate1, 'YYYY/MM/DD');
    var fromDate = {
      year: parseInt(fromDate2.format('YYYY')),
      month: parseInt(fromDate2.format('M')),
      day: parseInt(fromDate2.format('D')),
    };
    console.log(fromDate);
    var toDate1 = new Date(partner.toDate);
    var toDate2 = moment(toDate1, 'YYYY/MM/DD');
    var toDate = {
      year: parseInt(toDate2.format('YYYY')),
      month: parseInt(toDate2.format('M')),
      day: parseInt(toDate2.format('D')),
    };
    console.log(toDate);

    let partnerFormGroup = this.fb.group({
      id: [partner.id],
      assignments: [partner.assignments, Validators.required],
      fromDate: [fromDate, Validators.required],
      toDate: [toDate, Validators.required],
    });

    (<FormArray>this.formObj.get('partners')).push(partnerFormGroup);
  }

  location: FormGroup;
  addLocationFormGroupInEdit(location) {
    const stateIndex = this.stateList.findIndex(
      (item) => item.id == location.state.id
    );
    // const cityIndex = this.clientCityList.findIndex((item) => item.id == location.city.id);
    // const postcodeIndex = this.clientPostcodeList.findIndex((item) => item.id == location.postCode.id);
    this.locationCityList.push([]);
    this.locationPostCodeList.push([]);
    (<FormArray>this.formObj.get('clientLocations')).push(
      this.fb.group({
        id: [location.id],
        distance: [location.distance, Validators.required],
        address: [location.address, [Validators.required]],
        state: [this.stateList[stateIndex], [Validators.required]],
        city: [location.city, [Validators.required]],
        postCode: [location.postCode, [Validators.required]],
      })
    );
  }

  //Setting
  changeModalFormObjList(modalFormObj) {
    if (this.formStatus == 'add') {
      this.formObjList.push(modalFormObj);
    }
    if (this.formStatus == 'edit') {
      var index = this.formObjList.findIndex(
        (item) => item.id === modalFormObj.id
      );
      this.formObjList.splice(index, 1, modalFormObj);
    }
    if (this.formStatus == 'delete') {
      var index = this.formObjList.findIndex(
        (item) => item.id === modalFormObj.id
      );
      this.formObjList.splice(index, 1);
    }
  }

  getErrorMessage(control: AbstractControl): string {
    if (control.hasError('required')) {
      return 'Mandatory field';
    }
    if (control.hasError('maxlength')) {
      return 'Maximum length is 21 digits.';
    }
    if (control.hasError('pattern')) {
      return 'Invalid format';
    }
    return '';
  }

  logValidationErrors(group: FormGroup = this.formObj): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);

      this.formErrors[key] = '';
      console.log('abstractControl', abstractControl.valid, abstractControl)
      if (abstractControl && !abstractControl.valid && this.formSubmitted) {
        const messages = this.formValidationMessages[key];
        console.log('formErrors', this.formErrors)
        for (const errorKey in abstractControl.errors) {
          if (errorKey) {
            this.formErrors[key] += messages[errorKey] + ' ';
          }
        }
      }
      console.log('formErrors', this.formErrors)
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      }

      // if (abstractControl instanceof FormArray) {
      //   for (const control of abstractControl.controls) {
      //     if (control instanceof FormGroup) {
      //       this.logValidationErrors(control);
      //     }
      //   }
      // }
    });
  }

  onCountChange(manDaysCount, index) {
    console.log("budgetDetailsIndex", this.formObj.controls.budgetDetails.controls[index])
    console.log("editGlobalResponse", this.editGlobalResponse)
    for (let i = 0; i < this.editGlobalResponse.budget.length; i++) {
      if (this.editGlobalResponse.budget[i].assignment != null) {
        if (this.formObj.controls.budgetDetails.controls[index].value.assignment.id == this.editGlobalResponse.budget[i].assignment.id
          && this.formObj.controls.budgetDetails.controls[index].value.partner.id == this.editGlobalResponse.budget[i].assignedPartner.id) {
          for (let j = 0; j < this.editGlobalResponse.budget[i].budgetDetails.length; j++) {
            if (this.editGlobalResponse.budget[i].budgetDetails[j].id == this.formObj.controls.budgetDetails.controls[index].value.id) {
              this.editGlobalResponse.budget[i].budgetDetails[j].count = this.formObj.controls.budgetDetails.controls[index].value.count
            }
          }
        }
      }
      console.log("aftereditGlobalResponse", this.editGlobalResponse)
    }
  }

  clickOnManyDay(budgetDetail, index) {
    var manDaysCount;
    var fyId = this.formObj.value.financialYear.id;
    var userId = budgetDetail.value.user.id;

    if ((budgetDetail.value.budgetedDays) % 0.5 == 0) {
    } else {
      this.commonMessageService.swalAlertWithoutIcon('', 'Please enter valid man days.');
      this.formObj.controls.budgetDetails.controls[index].patchValue({
        budgetedDays: 0,
      });
    }

    console.log('before add');
    if (this.formStatus == 'add') {
      manDaysCount = budgetDetail.value.budgetedDays;
      console.log('mandays count', manDaysCount);

      this.masterDataService
        .getManDaysInBudgetClientDetails(fyId, userId)
        .subscribe((res) => {
          if (budgetDetail.value.role.name != 'Article') {
            if (res != null) {
              console.log('budgetedDays count', res.budgetedDays);
              var totalManDaysCount = res.budgetedDays + manDaysCount;
              console.log('totalManDaysCount count', totalManDaysCount);
              if (totalManDaysCount > 5000) {
                this.commonMessageService.swalAlertWithoutIcon('', 'Man Days count is higher that 5000 So please make it less');
                this.formObj.controls.budgetDetails.controls[index].patchValue({
                  budgetedDays: 0,
                });
              }
            } else {
              if (manDaysCount > 5000) {
                this.commonMessageService.swalAlertWithoutIcon('', 'Man Days count is higher that 5000 So please make it less');
                this.formObj.controls.budgetDetails.controls[index].patchValue({
                  budgetedDays: 0,
                });
              }
            }
          } else {
            this.formObj.controls.budgetDetails.controls[index].patchValue({
              budgetedDays: budgetDetail.value.budgetedDays,
            });
          }
        });
    }
    console.log('after add');
    if (this.formStatus == 'edit') {
      console.log('budget details', budgetDetail.value.budgetedDays);
      console.log('onAssignmentSelectBudgetDays details', this.onAssignmentSelectBudgetDays);
      if (this.onAssignmentSelectBudgetDays != undefined && budgetDetail.value.budgetedDays > this.onAssignmentSelectBudgetDays.budgetDetails[index].budgetedDays) {
        manDaysCount = (budgetDetail.value.budgetedDays - this.onAssignmentSelectBudgetDays.budgetDetails[index].budgetedDays);

        this.masterDataService
          .getManDaysInBudgetClientDetails(fyId, userId)
          .subscribe((res) => {
            if (budgetDetail.value.role.name != 'Article') {
              if (res != null) {
                console.log('budgeted days', res.budgetedDays);
                var totalManDaysCount = res.budgetedDays + manDaysCount;
                console.log('totalManDaysCount days', totalManDaysCount);
                if (totalManDaysCount > 5000) {
                  this.commonMessageService.swalAlertWithoutIcon('', 'Man Days count is higher that 5000 So please make it less');
                  this.formObj.controls.budgetDetails.controls[index].patchValue({
                    budgetedDays: this.onAssignmentSelectBudgetDays.budgetDetails[index].budgetedDays,
                  });
                  for (let i = 0; i < this.editGlobalResponse.budget.length; i++) {
                    if (this.editGlobalResponse.budget[i].assignment != null) {
                      if (this.formObj.controls.budgetDetails.controls[index].value.assignment.id == this.editGlobalResponse.budget[i].assignment.id
                        && this.formObj.controls.budgetDetails.controls[index].value.partner.id == this.editGlobalResponse.budget[i].assignedPartner.id
                        && this.formObj.controls.budgetDetails.controls[index].value.financialYear.id == this.editGlobalResponse.budget[i].financialYear.id) {
                        for (let j = 0; j < this.editGlobalResponse.budget[i].budgetDetails.length; j++) {
                          if (this.editGlobalResponse.budget[i].budgetDetails[j].id == this.formObj.controls.budgetDetails.controls[index].value.id) {
                            this.editGlobalResponse.budget[i].budgetDetails[j].budgetedDays = this.formObj.controls.budgetDetails.controls[index].value.budgetedDays
                          }
                        }
                      }
                    }
                  }
                }
              } else {
                if (manDaysCount > 5000) {
                  this.commonMessageService.swalAlertWithoutIcon('', 'Man Days count is higher that 5000 So please make it less');
                  this.formObj.controls.budgetDetails.controls[index].patchValue({
                    budgetedDays: this.onAssignmentSelectBudgetDays.budgetDetails[index].budgetedDays,
                  });
                  for (let i = 0; i < this.editGlobalResponse.budget.length; i++) {
                    if (this.editGlobalResponse.budget[i].assignment != null) {
                      if (this.formObj.controls.budgetDetails.controls[index].value.assignment.id == this.editGlobalResponse.budget[i].assignment.id
                        && this.formObj.controls.budgetDetails.controls[index].value.partner.id == this.editGlobalResponse.budget[i].assignedPartner.id
                        && this.formObj.controls.budgetDetails.controls[index].value.financialYear.id == this.editGlobalResponse.budget[i].financialYear.id) {
                        for (let j = 0; j < this.editGlobalResponse.budget[i].budgetDetails.length; j++) {
                          if (this.editGlobalResponse.budget[i].budgetDetails[j].id == this.formObj.controls.budgetDetails.controls[index].value.id) {
                            this.editGlobalResponse.budget[i].budgetDetails[j].budgetedDays = this.formObj.controls.budgetDetails.controls[index].value.budgetedDays
                          }
                        }
                      }
                    }
                  }
                }
              }
            } else {
              console.log('inside article else condition', budgetDetail.value.budgetedDays);
              for (let i = 0; i < this.editGlobalResponse.budget.length; i++) {
                if (this.editGlobalResponse.budget[i].assignment != null) {
                  if (this.formObj.controls.budgetDetails.controls[index].value.assignment.id == this.editGlobalResponse.budget[i].assignment.id
                    && this.formObj.controls.budgetDetails.controls[index].value.partner.id == this.editGlobalResponse.budget[i].assignedPartner.id
                    && this.formObj.controls.budgetDetails.controls[index].value.financialYear.id == this.editGlobalResponse.budget[i].financialYear.id) {
                    for (let j = 0; j < this.editGlobalResponse.budget[i].budgetDetails.length; j++) {
                      if (this.editGlobalResponse.budget[i].budgetDetails[j].id == this.formObj.controls.budgetDetails.controls[index].value.id) {
                        this.editGlobalResponse.budget[i].budgetDetails[j].budgetedDays = budgetDetail.value.budgetedDays
                      }
                    }
                  }
                }
              }
            }
          });
      } else {
        console.log('inside else Main else');
        for (let i = 0; i < this.editGlobalResponse.budget.length; i++) {
          if (this.editGlobalResponse.budget[i].assignment != null) {
            if (this.formObj.controls.budgetDetails.controls[index].value.assignment.id == this.editGlobalResponse.budget[i].assignment.id
              && this.formObj.controls.budgetDetails.controls[index].value.partner.id == this.editGlobalResponse.budget[i].assignedPartner.id
              && this.formObj.controls.budgetDetails.controls[index].value.financialYear.id == this.editGlobalResponse.budget[i].financialYear.id) {
              for (let j = 0; j < this.editGlobalResponse.budget[i].budgetDetails.length; j++) {
                if (this.editGlobalResponse.budget[i].budgetDetails[j].id == this.formObj.controls.budgetDetails.controls[index].value.id) {
                  this.editGlobalResponse.budget[i].budgetDetails[j].budgetedDays = this.formObj.controls.budgetDetails.controls[index].value.budgetedDays
                }
              }
            }
          }
        }
      }
    }
  }
}
